export const cmsLiftBlock = {
  sys: {
    space: {
      sys: {
        type: 'Link',
        linkType: 'Space',
        id: 'bh7k0sgo84rb'
      }
    },
    id: '6z9n60DMqV5YQzUatWnWx1',
    type: 'Entry',
    createdAt: '2020-01-16T13:40:50.816Z',
    updatedAt: '2020-01-16T13:40:50.816Z',
    environment: {
      sys: {
        id: 'sandbox1',
        type: 'Link',
        linkType: 'Environment'
      }
    },
    revision: 1,
    contentType: {
      sys: {
        type: 'Link',
        linkType: 'ContentType',
        id: 'liftBlock'
      }
    },
    locale: 'fi-FI'
  },
  fields: {
    title: 'Tutustu unohtumattomiin lomamuistoihin',
    mainLift: {
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'bh7k0sgo84rb'
          }
        },
        id: '5Y56lNXYUfRGmxe4pMHDGy',
        type: 'Entry',
        createdAt: '2020-01-09T14:35:41.051Z',
        updatedAt: '2020-01-09T14:35:41.051Z',
        environment: {
          sys: {
            id: 'sandbox1',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'experiencePhase'
          }
        },
        locale: 'fi-FI'
      },
      fields: {
        label: 'Tunnelmaa ja ostoksia',
        title: 'Entisen Itä-Berliinin tunnelmaa ja ostoksia lännessä',
        mainMedia: {
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'bh7k0sgo84rb'
              }
            },
            id: '1Do2c1C8NUx9Jg8vzK6qJR',
            type: 'Asset',
            createdAt: '2020-01-09T14:35:35.893Z',
            updatedAt: '2020-01-09T14:35:35.893Z',
            environment: {
              sys: {
                id: 'sandbox1',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            revision: 1,
            locale: 'fi-FI'
          },
          fields: {
            title: 'Alexanderplatz',
            description: 'Berliiniä Alexanderplatzin ympäristössä.',
            file: {
              url: '//localhost:3000/static/test/dummy-image.png',
              details: {
                size: 9198938,
                image: {
                  width: 3024,
                  height: 4032
                }
              },
              fileName:
                'Itä-Berliinin-alueella-Alexanderplatzin-ympäristössä.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        content:
          'Kauniina kesäiltana monipuolisten nähtävyyksien kiertelyn jälkeen kävimme tyttären kanssa vielä Alexanderplatzin ympäristössä entisen Itä-Berliinin puolella. Alue oli yllättävän rauhallinen elämää kuhisevan miljoonakaupungin mittapuulla.\n\nVaalean pastellin sävyiset vanhat talot olivat kauniita ja liikkeet tyylikkäitä. Pienet, viehättävät kortteliravintolat vetivät ihmisiä nauttimaan herkullisista aterioista, kuplivista juomista ja lempeästä kesäillasta.\n\nMeillä ostoksien aika oli vasta seuraavana päivänä. Nuoret löysivät kaikki suosikkikauppansa Ku’dammin (Kurfürstendamm ympäristöineen) kierroksella ja ostoskassit täyttyivät edullisista löydöistä. Kiitimme onneamme, että osuimme paikalle aleaikaan! '
      }
    },
    mainLiftTitle: 'Suosituin Lomakokemus',
    bottomLifts: [
      {
        sys: {
          space: {
            sys: {
              type: 'Link',
              linkType: 'Space',
              id: 'bh7k0sgo84rb'
            }
          },
          id: '7gM0BY8gAYm62Fu2TwyzoJ',
          type: 'Entry',
          createdAt: '2020-01-09T14:45:44.265Z',
          updatedAt: '2020-01-09T14:45:44.265Z',
          environment: {
            sys: {
              id: 'sandbox1',
              type: 'Link',
              linkType: 'Environment'
            }
          },
          revision: 1,
          contentType: {
            sys: {
              type: 'Link',
              linkType: 'ContentType',
              id: 'memory'
            }
          },
          locale: 'fi-FI'
        },
        fields: {
          title: 'Perheen kaupunkiloma Berliinissä herkutellen',
          slug: 'perheen-kaupunkiloma-berliinissa-herkutellen',
          leadParagraph:
            'Teimme kesällä kolmen päivän kaupunkiloman teinien toivekaupunkikohteeseen Berliiniin. Rosoinen suurkaupunki viehätti koskettavine historioineen, monipuolisine nähtävyyksineen ja maittavine ruokapaikkoineen.',
          trip: {
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'bh7k0sgo84rb'
                }
              },
              id: '4Y08aRL6TvxQBRRtJQgKot',
              type: 'Entry',
              createdAt: '2020-01-09T14:05:38.989Z',
              updatedAt: '2020-01-09T14:05:38.989Z',
              environment: {
                sys: {
                  id: 'sandbox1',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'trip'
                }
              },
              locale: 'fi-FI'
            },
            fields: {
              title: 'Berliinin kaupunkiloma',
              erpTripId: 860
            }
          },
          mainImage: {
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'bh7k0sgo84rb'
                }
              },
              id: '3rMqIbljnAk0Kmn5uxUGAt',
              type: 'Asset',
              createdAt: '2020-01-09T14:41:48.568Z',
              updatedAt: '2020-01-09T14:41:48.568Z',
              environment: {
                sys: {
                  id: 'sandbox1',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              revision: 1,
              locale: 'fi-FI'
            },
            fields: {
              title: 'Berliinin Tuomiokirkko',
              description:
                'Berliinin Tuomiokirkko komeilee jykevänä taustalla.',
              file: {
                url: '//localhost:3000/static/test/dummy-image.png',
                details: {
                  size: 8341330,
                  image: {
                    width: 3024,
                    height: 4032
                  }
                },
                fileName: 'Berliner-Dom---Berliinin-Tuomiokirkko.jpg',
                contentType: 'image/jpeg'
              }
            }
          },
          startDate: '2020-01-01',
          endDate: '2020-01-04',
          travellers: [
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '3OrIlKoWrLzg2Z0MPziJX7',
                type: 'Entry',
                createdAt: '2020-01-09T13:55:13.620Z',
                updatedAt: '2020-01-10T10:09:20.366Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 2,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'traveller'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                profilePicture: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '5ETEflYMgFT0MEiuEBSnyM',
                    type: 'Asset',
                    createdAt: '2020-01-09T13:55:07.542Z',
                    updatedAt: '2020-01-10T10:09:15.701Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 2,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Arja Virta',
                    file: {
                      url:
                        '//images.ctfassets.net/bh7k0sgo84rb/5ETEflYMgFT0MEiuEBSnyM/0df24bcc7a3d0964054ee231be08b0d5/Arja_Eze_082018.png',
                      details: {
                        size: 4544625,
                        image: {
                          width: 1936,
                          height: 1452
                        }
                      },
                      fileName: 'Arja Eze 082018.png',
                      contentType: 'image/png'
                    }
                  }
                },
                title: 'Arja Virta',
                firstName: 'Arja',
                slug: 'arja-virta',
                shortInfo: 'Kauniita maisemia rakastava reissaaja',
                residence: 'Turku',
                instagramHandle: 'instagram.com/elamanmakuisiamatkoja',
                homepage: {
                  sys: {
                    type: 'Link',
                    linkType: 'Entry',
                    id: '7FjypyBp04HeYDQdlbda1f'
                  }
                },
                leadParagraph:
                  'Matkustan usein perheen kanssa. Lapset ovat teini-ikäisiä, yksi jo aikuinenkin. Haluamme\nnähdä maailmaa ja tutustua kohteisiin myös nuorten näkökulmasta, samalla perheen kanssa\naikaa viettäen.'
              }
            }
          ],
          phases: [
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '1C3rxDtoWUjDueI63OlYXk',
                type: 'Entry',
                createdAt: '2020-01-09T14:45:16.203Z',
                updatedAt: '2020-01-09T14:45:16.203Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'travelPhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'Turku–Berliini',
                title: 'Matka alkoi aamulennolla Turusta Berliiniin',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '3z2Gy1ehP56BC53xR5Zv1k',
                    type: 'Asset',
                    createdAt: '2020-01-09T14:45:04.554Z',
                    updatedAt: '2020-01-09T14:45:04.554Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Tunnelmaa',
                    description:
                      'Tällaisiin tunnelmiin perhematka johti entisessä Itä-Berliinissä.',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 9872962,
                        image: {
                          width: 2891,
                          height: 3854
                        }
                      },
                      fileName: 'Tunnelmaa-entisen-Ita-Berliinin-alueelta.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Matkaan Turusta lähdimme aamuvarhaisella auringon piirtäessä kultaisia ja punertavia sävyjään taivaanrantaan. Jo ensimmäisenä päivänä ehdimme viettää koko päivän perillä ja kesäisen kansainvälinen suurkaupunki tempaisi meidät sykkeeseensä. '
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '6JIVu8lbLDujQzeSC6pxhP',
                type: 'Entry',
                createdAt: '2020-01-09T14:22:22.699Z',
                updatedAt: '2020-01-09T14:22:22.699Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'hotelPhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'Scandic Potsdamer Platz',
                title:
                  'Hotellin Scandic Potsdamer Platzin sijainti oli keskeinen',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '65R8UxO3TZ0JVPvUFHchjV',
                    type: 'Asset',
                    createdAt: '2020-01-09T14:15:49.173Z',
                    updatedAt: '2020-01-09T14:15:49.173Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Potsdamer Platzin asemalla',
                    description:
                      'Potsdamer Platzin asemaa ympäröivät mielenkiintoisen näköiset rakennukset.',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 2211397,
                        image: {
                          width: 2721,
                          height: 3629
                        }
                      },
                      fileName: 'Potsdamer Platzin asemalla.JPG',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Scandic Potsdamer Platz -hotellin keskeinen sijainti helpotti liikkumista kaupungissa.  U-Bahn asema on vieressä ja junan ikkunasta voi ihailla suurkaupungin siluettia ja ihmisvilinää. Potsdamer Platz -aukion ja ympäristön arkkitehtoniset ratkaisut ja minimalistiset rakennukset miellyttivät silmää.'
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '2BbZKfmgfSawtDtO1PpWJ',
                type: 'Entry',
                createdAt: '2020-01-09T14:21:51.354Z',
                updatedAt: '2020-01-09T14:21:51.354Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'experiencePhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'Makunautintoja',
                title: 'Makunautintoja Potsdamer Platzilla ',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: 'CVwwRWd55HJiUbEvfMf93',
                    type: 'Asset',
                    createdAt: '2020-01-09T14:21:05.873Z',
                    updatedAt: '2020-01-09T14:21:32.551Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 2,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Que Pasa -ravintolassa',
                    description:
                      'Nautimme hyvästä meksikolaisesta ruuasta Que Pasa -ravintolassa.',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 1493879,
                        image: {
                          width: 2095,
                          height: 3724
                        }
                      },
                      fileName: 'Que Pasa -ravintolassa.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Berliinin ruokatarjonta on todella monipuolista ja herkullista. Jo ensimmäisenä iltana löysimme perheemme suosikkiravintolan Potsdamer Platzilta. Meksikolaisen Que Pasa -ravintolan terassilla oli miellyttävä istua lämpimänä kesäiltana ja ravintolan ruuat hivelivät makuaisteja. Perheen nirsot teinitkin kehuivat annoksiaan ylitsevuotavasti. Hinta-laatusuhde oli erinomainen, paikka viihtyisä ja ruoka erinomaista. Que Pasa sai meidän perheeltämme täydet viisi pistettä kahden illan kokemuksella.'
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '2F0ewR2NHYQPIVjIyO0yKl',
                type: 'Entry',
                createdAt: '2020-01-09T14:27:41.219Z',
                updatedAt: '2020-01-09T14:27:41.219Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'experiencePhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'Herkkuja ja shoppailua',
                title: 'Herkkuja ja shoppailua KaDeWessa',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: 'GjuuqbslZfJSF2fECMUe2',
                    type: 'Asset',
                    createdAt: '2020-01-09T14:27:25.787Z',
                    updatedAt: '2020-01-09T14:27:25.787Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'KaDeWen herkkuosastolla',
                    description:
                      'Suklaiset ja marjaiset herkut vievät kielen mennessään.',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 2692070,
                        image: {
                          width: 4032,
                          height: 3024
                        }
                      },
                      fileName: 'KaDeWe-tavaratalon herkkuosastolla.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Ihania herkkuja ja kauniita esillepanoja ihailimme myös KaDeWessa (Kaufhaus des Westens eli Lännen tavaratalo). Ylellinen ostospaikka on suuri, Lontoon Harrodsin mieleen tuova luksustavaratalo. Yläkerroksen foodmarketissa oli muun muassa ihania, suklaisia ja marjaisia herkkuja, tuoreita ruokatarvikkeita ja herkullisen värisiä juomia houkuttelevasti esillä. Himoitsimme niitä myös kotiin vietäväksi, mutta valitettavasti matkustimme tällä kertaa vain käsimatkatavaroilla, joten ne jäivät hyllyille.'
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '5Y56lNXYUfRGmxe4pMHDGy',
                type: 'Entry',
                createdAt: '2020-01-09T14:35:41.051Z',
                updatedAt: '2020-01-09T14:35:41.051Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'experiencePhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'Tunnelmaa ja ostoksia',
                title: 'Entisen Itä-Berliinin tunnelmaa ja ostoksia lännessä',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '1Do2c1C8NUx9Jg8vzK6qJR',
                    type: 'Asset',
                    createdAt: '2020-01-09T14:35:35.893Z',
                    updatedAt: '2020-01-09T14:35:35.893Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Alexanderplatz',
                    description: 'Berliiniä Alexanderplatzin ympäristössä.',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 9198938,
                        image: {
                          width: 3024,
                          height: 4032
                        }
                      },
                      fileName:
                        'Itä-Berliinin-alueella-Alexanderplatzin-ympäristössä.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Kauniina kesäiltana monipuolisten nähtävyyksien kiertelyn jälkeen kävimme tyttären kanssa vielä Alexanderplatzin ympäristössä entisen Itä-Berliinin puolella. Alue oli yllättävän rauhallinen elämää kuhisevan miljoonakaupungin mittapuulla.\n\nVaalean pastellin sävyiset vanhat talot olivat kauniita ja liikkeet tyylikkäitä. Pienet, viehättävät kortteliravintolat vetivät ihmisiä nauttimaan herkullisista aterioista, kuplivista juomista ja lempeästä kesäillasta.\n\nMeillä ostoksien aika oli vasta seuraavana päivänä. Nuoret löysivät kaikki suosikkikauppansa Ku’dammin (Kurfürstendamm ympäristöineen) kierroksella ja ostoskassit täyttyivät edullisista löydöistä. Kiitimme onneamme, että osuimme paikalle aleaikaan! '
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '4NJ2SS79MDwnRV8OFwsrwK',
                type: 'Entry',
                createdAt: '2020-01-09T14:39:25.995Z',
                updatedAt: '2020-01-09T14:39:25.995Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'travelPhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'Positiivinen yllätys',
                title: 'Berliini oli positiivinen yllätys',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '3cysfevnyqlfZc2gVlxWiq',
                    type: 'Asset',
                    createdAt: '2020-01-09T14:39:20.725Z',
                    updatedAt: '2020-01-09T14:39:20.725Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Holocaust Memorial',
                    description: 'Lapset tutustumassa Holocaust Memorialiin.',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 1725233,
                        image: {
                          width: 3654,
                          height: 2740
                        }
                      },
                      fileName: 'Lapset Holocaust Memorialilla.JPG',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Ennakko-odotuksiini nähden kokemus Berliinistä oli yllättävän positiivinen. Kaupunki ei niinkään hurmannut kauneudellaan, mutta suurkaupungista löytyi kuitenkin taidokasta arkkitehtuuria ja rosoista vetovoimaa. Rento, kansainvälinen ilmapiiri ja ruuhkattomuus muutamia suosituimpia nähtävyyksiä lukuun ottamatta vetosivat sekä aikuisiin että nuoriin.'
              }
            }
          ],
          destinations: [
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '4NGGMKDbUykH0PzSSFDd84',
                type: 'Entry',
                createdAt: '2020-01-09T14:06:06.850Z',
                updatedAt: '2020-01-09T14:06:06.850Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'destination'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                title: 'Berliini',
                slug: 'berliini',
                mainImage: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '6btFJxs7VWn8AeCJncdyR0',
                    type: 'Asset',
                    createdAt: '2020-01-09T14:04:10.992Z',
                    updatedAt: '2020-01-09T14:04:10.992Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Berliini',
                    description: 'Berliini, Saksa',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 28825,
                        image: {
                          width: 300,
                          height: 200
                        }
                      },
                      fileName: 'berliini-saksa-016-300x200.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                country: 'Saksa',
                cityErpId: 856,
                leadParagraph: 'TBD',
                description: 'TBD',
                trips: [
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '4Y08aRL6TvxQBRRtJQgKot',
                      type: 'Entry',
                      createdAt: '2020-01-09T14:05:38.989Z',
                      updatedAt: '2020-01-09T14:05:38.989Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: 'Link',
                          linkType: 'ContentType',
                          id: 'trip'
                        }
                      },
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Berliinin kaupunkiloma',
                      erpTripId: 860
                    }
                  }
                ]
              }
            }
          ]
        }
      },
      {
        sys: {
          space: {
            sys: {
              type: 'Link',
              linkType: 'Space',
              id: 'bh7k0sgo84rb'
            }
          },
          id: '29MDz1h6lWXipHbw0odFms',
          type: 'Entry',
          createdAt: '2020-01-09T13:43:39.543Z',
          updatedAt: '2020-01-09T13:43:39.543Z',
          environment: {
            sys: {
              id: 'sandbox1',
              type: 'Link',
              linkType: 'Environment'
            }
          },
          revision: 1,
          contentType: {
            sys: {
              type: 'Link',
              linkType: 'ContentType',
              id: 'memory'
            }
          },
          locale: 'fi-FI'
        },
        fields: {
          title: 'Vauvan kanssa rakkaassa Barcelonassamme',
          slug: 'vauvan-kanssa-rakkaassa-barcelonassamme',
          leadParagraph:
            'Kun perheemme oli kasvanut pikkuihmisellä ja tuli aika miettiä ensimmäistä ulkomaanmatkaa vauvan kanssa, Barcelona oli itsestäänselvä valinta. Halusimme näyttää tyttärellemme – vaikka hän ei niitä tulisikaan muistamaan – meille tärkeitä paikkoja sekä nauttia tietysti kiireettömästä lomasta perheen kesken.',
          trip: {
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'bh7k0sgo84rb'
                }
              },
              id: '3CGT8DM1fF9WYt9wY87JKj',
              type: 'Entry',
              createdAt: '2020-01-09T13:39:36.059Z',
              updatedAt: '2020-01-09T13:39:36.059Z',
              environment: {
                sys: {
                  id: 'sandbox1',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'trip'
                }
              },
              locale: 'fi-FI'
            },
            fields: {
              title: 'Barcelonan kaupunkiloma',
              erpTripId: 1010
            }
          },
          mainImage: {
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'bh7k0sgo84rb'
                }
              },
              id: '6S2Lts6uTmMLGfkU9rBk7l',
              type: 'Asset',
              createdAt: '2020-01-09T13:27:39.229Z',
              updatedAt: '2020-01-09T13:27:39.229Z',
              environment: {
                sys: {
                  id: 'sandbox1',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              revision: 1,
              locale: 'fi-FI'
            },
            fields: {
              title: 'Barcelonan kadut',
              description:
                'Barcelonasta löytyy avoimia ja vehreitä promenadeja.',
              file: {
                url: '//localhost:3000/static/test/dummy-image.png',
                details: {
                  size: 8683471,
                  image: {
                    width: 3264,
                    height: 2392
                  }
                },
                fileName: 'IMG_3299.jpg',
                contentType: 'image/jpeg'
              }
            }
          },
          startDate: '2019-11-09',
          endDate: '2019-11-12',
          travellers: [
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '5MiZZmdXl91hAt7EmISiGN',
                type: 'Entry',
                createdAt: '2020-01-09T10:37:40.665Z',
                updatedAt: '2020-01-09T10:40:58.604Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 2,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'traveller'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                profilePicture: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '7vqCE45GhwEpjpI6y2vXBJ',
                    type: 'Asset',
                    createdAt: '2020-01-09T10:37:24.526Z',
                    updatedAt: '2020-01-09T10:37:24.526Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Arna Grym',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 6075003,
                        image: {
                          width: 4928,
                          height: 3264
                        }
                      },
                      fileName: 'ES-BCN-pass-casa-zwietr.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                title: 'Arna Grym',
                firstName: 'Arna',
                slug: 'arna-grym',
                shortInfo: 'Lapsiperhematkailua',
                residence: 'Helsinki',
                leadParagraph:
                  'Barcelona on meille perheen vanhemmille tärkeä kaupunki. Olemme viettäneet siellä 15 yhteisen vuotemme aikana monta ikimuistoista lomaa, niin kahdestaan kuin ystävien ja perheen kanssa. Olemme kiintyneet Barcelonaan niin, että kutsumme sitä joskus toiseksi kodiksemme, vaikka emme ole siellä varsinaisesti koskaan asuneet. Mutta goottilaisen kaupunginosan kujat, Barcelonetan palmut ja Eixamplen modernistiarkkitehtuuri ovat meille niin tuttuja, että Barcelonaan saapuminen tuntuu joka kerta siltä kuin palaisi kotiin.'
              }
            }
          ],
          phases: [
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '4ejpH1rvLEwoYqh6xgTVCx',
                type: 'Entry',
                createdAt: '2020-01-09T10:51:36.372Z',
                updatedAt: '2020-01-09T10:51:36.372Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'travelPhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'Vauvan ensimmäinen lento',
                title: 'Vauvan ensimmäinen lento sujui hyvin',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '3mg8kWyVk7Hv4FdthvkEAA',
                    type: 'Asset',
                    createdAt: '2020-01-09T10:48:05.592Z',
                    updatedAt: '2020-01-09T10:48:05.592Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Seikkailun tuntua',
                    description:
                      'Kotipihasta lähtiessä ilmassa on seikkailun tuntua. Pian nähdään, Barcelona!',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 1223718,
                        image: {
                          width: 1280,
                          height: 960
                        }
                      },
                      fileName: 'IMG_0566.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Raahatessamme kahta matkalaukkua, paria reppua, vauvan turvakaukaloa ja tietysti itse vauvaa matkarattaineen kohti bussipysäkkiä, ehdimme hieman katua sitä, ettemme tilanneet taksia, mutta lopulta matka meni varsin kivuttomasti – ja säästimme muutaman kympin kohteessa tuhlattavaksi.\n\nLentomatkaa olimme jännittäneet etukäteen eniten, sillä emme osanneet ennustaa miten yhdeksänkuinen vauva jaksaisi istua paikallaan neljä tuntia. Olimme varanneet hänelle viihdykettä lennon ajaksi, mutta lopulta ohjelmanumeroksi riitti käsinojassa oleva nappi, turvavyön häntä ja lentoyhtiön lehti. Sekä ruoka, maito ja unet. Yhtään itkua ei koko lentomatkan aikana kuultu, mistä saimme kiitosta myös kanssamatkustajilta: “Kiltti vauva!”. Kiltteydellä tuskin oli asian kanssa tekemistä, mutta huokasimme helpotuksesta, että lento meni niin hyvin.\n\nBarcelonan päässä ei tullut mieleenkään alkaa kikkailla julkisten kanssa, vaan hyppäsimme taksiin, joka hurautti meidät hetkessä Eixamplen kaupunginosassa sijaitsevaan hotelliimme.',
                media: [
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '4gi74jiK75tYsCa1eGTdTq',
                      type: 'Asset',
                      createdAt: '2020-01-09T10:50:52.385Z',
                      updatedAt: '2020-01-09T10:50:52.385Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Vauva kantorepussa',
                      description:
                        'Matkarattaat matkustivat kohteeseen ruumassa, joten lentokentällä vauva kulki kätevimmin kantorepussa.',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 5269730,
                          image: {
                            width: 2182,
                            height: 2985
                          }
                        },
                        fileName: 'IMG_2846.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  }
                ]
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '2wuNIVCHY01Y73IRqH4ki7',
                type: 'Entry',
                createdAt: '2020-01-09T11:05:11.495Z',
                updatedAt: '2020-01-09T11:05:11.495Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'hotelPhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'H10 Art Gallery',
                title: 'Hotellissa tärkeintä oli sijainti ja parveke',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: 'CEzu0wSwywib2stR3h6as',
                    type: 'Asset',
                    createdAt: '2020-01-09T10:55:04.598Z',
                    updatedAt: '2020-01-09T10:55:04.598Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Deluxe-huone',
                    description:
                      'H10 Art Gallery -hotellin parvekkeellinen deluxe-huone oli riittävän kokoinen kolmehenkiselle perheelle matkatavaroineen. Lapsen matkasänkykin mahtui nipin napin, sen saimme hotellin puolesta.',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 14959714,
                        image: {
                          width: 5184,
                          height: 3456
                        }
                      },
                      fileName: 'IMG_0755.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Hotellivalintamme oli H10 Art Gallery Barcelonan herkullisimmalla kadulla, Enric Granadosilla. Olemme muutamilla aiemmilla reissuillamme majoittuneet Airbnb-huoneistoissa, mutta liikaturismin vaivaamassa Barcelonassa Airbnb on vääristänyt asuntomarkkinoita siinä määrin, että hotelli on nykyisin ainoa vastuullinen vaihtoehto.\n\nMeille tärkein kriteeri hotellin valinnassa on sijainti. Emme halua lomalla käyttää aikaa liikennevälineissä istumiseen, joten suunnittelemme ensin, mitä aiomme kohteessa tehdä ja varaamme sitten hotellin keskeltä tapahtumapaikkoja. Eixample on monipuolisen ravintolatarjontansa ansiosta lempikaupuinginosiamme Barcelonassa, joten päätimme tälläkin kertaa majoittua lähellä parhaita ravintoloita, sillä ohjelmassa oli ennen kaikkea herkuttelua.\n\nHotellissa meitä oli vastassa modernismia henkivä avara aula, jonka värikkäät taideteokset olivat tehneet meihin vaikutuksen jo nettisivuja selaillessa. Nopean sisäänkirjautumisen jälkeen hurautimme näköalahissillä kerrokseemme, jossa parvekkeellinen huoneemme vauvansänkyineen odotti valmiina. Emme yleensä Barcelonan kaltaisissa kaupunkikohteissa välitä maksaa extraa lisämukavuuksista, sillä hotellissa tulee käytyä lähinnä nukkumassa, mutta tällä kertaa halusimme mahdollisuuden viettää aikaa aikuisten kesken lapsen mentyä alkuillasta nukkumaan, joten olimme valinneet parvekkeellisen huoneen.\n\nEnsimmäinen matkapäivämme päättyi varhaiseen illalliseen kortteliravintolassa, jonka olimme löytäneet opaskirjasta. Lasillinen täyteläistä punaviiniä ja annos mustekalaa galicialaisittain maistui taivaalliselta. Ah, Barcelona, kuinka meillä olikaan ollut ikävä!',
                media: [
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '2Iwob5gjznzwmeKcuVM8bB',
                      type: 'Asset',
                      createdAt: '2020-01-09T10:56:59.082Z',
                      updatedAt: '2020-01-09T10:56:59.082Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'KUVA: [DSCN3933]',
                      description:
                        'Näkymä parvekkeelta oli hyvin barcelonalainen.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 10657360,
                          image: {
                            width: 4000,
                            height: 3000
                          }
                        },
                        fileName: 'DSCN3933.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '30fqD0X2IKtkHDy4iosLvn',
                      type: 'Asset',
                      createdAt: '2020-01-09T10:58:54.275Z',
                      updatedAt: '2020-01-09T10:58:54.275Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Uima-allas',
                      description:
                        'Katolla sijaitseva uima-allas tuli meille iloisena yllätyksenä! Syyskuussa altaasta sai nauttia ihan keskenään, me kävimme yhtenä päivänä pulikoimassa vuorotellen sillä aikaa kun lapsi nukkui päiväunia – hyvin tarkeni.',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 6811037,
                          image: {
                            width: 3264,
                            height: 2448
                          }
                        },
                        fileName: 'IMG_0681.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '74tFdozKgobAIe6UfsbGIg',
                      type: 'Asset',
                      createdAt: '2020-01-09T11:01:07.777Z',
                      updatedAt: '2020-01-09T11:01:07.777Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Omaa aikaa altaalla',
                      description: 'Äidin omaa aikaa poolilla.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 819263,
                          image: {
                            width: 960,
                            height: 1280
                          }
                        },
                        fileName: 'IMG_0685.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '6Jtx3KhdgWwS0eOxGiaZHu',
                      type: 'Asset',
                      createdAt: '2020-01-09T11:03:03.676Z',
                      updatedAt: '2020-01-09T11:03:03.676Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Salut!',
                      description: 'Salut, Barcelona! Olkoon lomamme hyvä!\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 6714932,
                          image: {
                            width: 2448,
                            height: 3264
                          }
                        },
                        fileName: 'IMG_0609.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '1yi8pZVlJ9IqiPFv57zG53',
                      type: 'Asset',
                      createdAt: '2020-01-09T11:04:40.010Z',
                      updatedAt: '2020-01-09T11:04:40.010Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Pulpo a la gallega',
                      description:
                        'Ensimmäinen puraisu on aina paras. Lempiannoksemme pulpo a la gallega hieman modernimman näköisenä versiona.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 4758544,
                          image: {
                            width: 3264,
                            height: 2448
                          }
                        },
                        fileName: 'IMG_0610.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  }
                ]
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '3cAaGKFGJrsRzNApocUqAC',
                type: 'Entry',
                createdAt: '2020-01-09T11:10:01.767Z',
                updatedAt: '2020-01-09T11:10:01.767Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'experiencePhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'Aamu katukuppilassa',
                title: 'Cortado ja bocadillo katukuppilassa aloittivat aamun',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '5uYUSZoa9JgX0RWIRa9l8u',
                    type: 'Asset',
                    createdAt: '2020-01-09T11:07:43.627Z',
                    updatedAt: '2020-01-09T11:07:43.627Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Katukuppila',
                    description:
                      'Tästä satunnaisesta katukuppilasta muodostui vakioaamiaispaikkamme\n',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 4138360,
                        image: {
                          width: 2265,
                          height: 3021
                        }
                      },
                      fileName: 'IMG_0624.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Emme ole suurten hotelliaamiaisten ystäviä, joten olimme tälläkin kertaa buukanneet majoituksen ilman aamiaista. Ensimmäiset kahvit nautimme hotellihuoneen kahvikoneesta aamutoimien lomassa ja toiset läheisessä kulmakuppilassa, josta muodostui viikon aikana vakiopaikkamme. Cortado, eli espresso tilkkasella maitoa, ja täytetty patonki riittivät aamiaiseksi aivan vallan mainiosti, ja kadun varressa istuessa, paikallista elämänmenoa seuratessa, pääsi kaupungin tunnelmaan ihan toisella tavalla kuin hotellin buffetissa.\n\nHeti ensimmäisenä aamuna saimme tuta barcelonalaisten lapsirakkauden. Kahvihetkemme aikana tyttärellemme kävivät lepertelemässä paitsi kahvilan henkilökunta ja viereisten pöytien asiakkaat myös useampi satunnainen ohikulkija. He ihastelivat estoitta lapsen vaaleita haituvia, kutittelivat masua ja ilveilivät hassusti. Lapsi rakasti joka hetkeä!\n\nViihdyimme kulmakuppilassamme niin hyvin, että olisimme voineet jäädä siihen vaikka koko päiväksi kadun vilinää seuraamaan. Mutta kaupunki kutsui ja sen kutsuun oli vastattava…',
                media: [
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '5MFXIeJHsL4LBCsg7IFx9V',
                      type: 'Asset',
                      createdAt: '2020-01-09T11:09:21.755Z',
                      updatedAt: '2020-01-09T11:09:21.755Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Kahvi, sämpylä ja aamun lehti',
                      description:
                        'Kahvi, sämpylä ja aamun lehti. Sillä se päivä lähtee käyntiin.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 4092807,
                          image: {
                            width: 2918,
                            height: 2339
                          }
                        },
                        fileName: 'IMG_2868.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  }
                ]
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '3GyT6vNDlzw45Emrqk1rJw',
                type: 'Entry',
                createdAt: '2020-01-09T11:26:16.623Z',
                updatedAt: '2020-01-09T11:26:16.623Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'experiencePhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'Sagrada Familia',
                title:
                  'Sagrada Familia on nähtävä kerran elämässä – tai kymmenen',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '3oBatfdVa5KIrfSxoT23g4',
                    type: 'Asset',
                    createdAt: '2020-01-09T11:15:03.979Z',
                    updatedAt: '2020-01-09T11:15:15.038Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 2,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Turistiposeeraus',
                    description:
                      'Saimme odottaa omaa vuoroamme turistiposeeraukseen hyvän tovin.\n',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 8850939,
                        image: {
                          width: 2448,
                          height: 3264
                        }
                      },
                      fileName: 'IMG_0641.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Olemme kiertäneet Barcelonan pakolliset nähtävyydet jo aiemmin, mutta on yksi, jota emme jätä väliin yhdelläkään matkalla: Sagrada Familia. Tuo satulinnamaisena kohti taivasta kohoava kirkko on niin näyttävä ilmestys, että ensi näkemällä se pistää haukkomaan henkeä, mutta vielä toisella, kolmannella ja neljännelläkin kerralla se saa ihokarvat nousemaan pystyyn. \n\nSagrada Familian rakennustyöt alkoivat jo vuonna 1882, mutta se ei ole vieläkään valmis. Tällä hetkellä katseet on käännetty vuoteen 2026, jolloin kirkon suunnittelijan Antoni Gaudín kuolemasta tulee kuluneeksi sata vuotta. Tuolloin kirkon toivotaan valmistuvan, ja niissä juhlallisuuksissa mekin toivomme voivamme olla mukana. Viidentoista vuoden aikana olemme saaneet nähdä useamman tornin kohoavan, ja joka kerta kirkko on näyttänyt vähän erilaiselta. Sisällä emme pistäytyneet tälläkään kertaa, vaan tyydyimme ihailemaan rakennusta etäältä ja ottamaan muutaman perhepotretin.',
                media: [
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '2XBTzqA2cm0o2438144tJm',
                      type: 'Asset',
                      createdAt: '2020-01-09T11:17:09.399Z',
                      updatedAt: '2020-01-09T11:17:09.399Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Lautapelailun hienot puitteet',
                      description:
                        'Paikalliset ukot olivat valinneet varsin vaikuttavat puitteet lautapelailulle.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 8810588,
                          image: {
                            width: 2448,
                            height: 3264
                          }
                        },
                        fileName: 'IMG_2874.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '5ldhrcauzEeIu6ZlTL8cyR',
                      type: 'Asset',
                      createdAt: '2020-01-09T11:21:38.025Z',
                      updatedAt: '2020-01-09T11:21:38.025Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Kaunis kuja',
                      description:
                        'Sagrada Familian ympäristö on turistimassoja sakeanaan, mutta väljempiä vesiä löytääkseen ei tarvitse kävellä kauas. Tämä kaunis kujanen sijaitsee kivenheiton päässä kirkosta. \n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 18208176,
                          image: {
                            width: 3456,
                            height: 5184
                          }
                        },
                        fileName: 'IMG_0777.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  }
                ]
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '2ENILUjaW54nAFVsVvzQD7',
                type: 'Entry',
                createdAt: '2020-01-09T11:32:03.462Z',
                updatedAt: '2020-01-09T11:56:37.506Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 2,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'experiencePhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'Lounas Sant Agustí Vellillä',
                title: 'Kiireetön lounas Sant Agustí Vellin aukiolla',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: 'b8wCgDTNCiSSqCUjel6wx',
                    type: 'Asset',
                    createdAt: '2020-01-09T11:31:42.523Z',
                    updatedAt: '2020-01-09T11:31:42.523Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Sant Agusti Vellin aukio ',
                    description:
                      'Sant Agusti Vellin aukio on Bornin piilotettu helmi.\n',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 8683471,
                        image: {
                          width: 3264,
                          height: 2392
                        }
                      },
                      fileName: 'IMG_3299.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Tunnelmallisen, mutta turistia pursuavan Barri Gòticin kainalossa lepää Bornin kaupunginosa, jonka kapeat kujat ja tunnelmalliset aukiot ovat aivan yhtä viehättäviä kuin goottilaisen naapurinsa, mutta tunnelma on paikallisempi. Parasta ajanvietettä Barcelonassa on jumahtaa jollekin sen aukioista nauttimaan kupillisesta kahvia, lasillisesta viiniä tai parhaimmillaan tuntikausia kestävästä lounaasta ja antaa kaupungin lipua ohitse. Sant Agustí Vellin aukio Bornissa on yksi Barcelonan piilotetuista helmistä ja kun pölähdimme satunnaiselta kujalta sen laidalle, tiesimme heti, että täällä tulemme viihtymään.\n\nKeskelle aukiota, vanhan katulampun ja vehreiden puiden varjoon oli pystytetty muutama terassipöytä. Aukion laidalla nuori nainen maalasi ovea kirkkain värein, skootteriparkissa parivaljakko kävi intensiivistä keskustelua. Tuuletusparvekkeilla liehuivat Katalonian liput. Takaamme lähestyvän kalkatuksen lähteeksi paljastui skeittaava buldoggi.\n\nIstahdimme tapasravintolan pöytään ja pian ystävällinen tarjoilija toi meille ruokalistat ja jäi hetkeksi viihdyttämään pellavapäistä vauvaa. Ruokaa odotellessa siemailimme kylmiä juomiamme; mies tarjoilijan suosittelemaa paikallista pienpanimo-olutta ja minä katalonialaista valkoviiniä. Lapsella oli oma pullo mukana. Uppouduimme aukion paikallistunnelmaan ja kuuntelimme salaa viereisten pöytien keskusteluja. Aurinko paistoi puun lehvien lomasta, eloisa puheensorina soljui ympärillämme kuin hyväntuulinen taustamusiikki. Ah, lomafiilis.\n\nKun tarjoilija alkoi kantaa ensimmäisiä tapasannoksia pöytään, lapsi olikin jo saanut tarpeekseen paikallaan kököttämisestä ja alkoi osoittaa mieltään kovaäänisesti. Maitopullo ja paikallisesta lelukaupasta ostettu monitoimilelu eivät enää riittäneet viihdykkeeksi, joten päätimme tottuneesti ottaa vuorot; toinen saisi syödä rauhassa ja toinen kärräisi lasta ympäri aukiota. \n\nMutta ruoka, se oli jumalaista! Ehdimme kippistää yhdessä tuoreille ostereille, kunnes toisen oli taas aika jatkaa kärryttelyä. Vuorovedoin kampasimpukat, anjovikset, lihapullat ja muut herkut katosivat parempiin suihin, ja täysin vatsoin matka sai taas jatkua – lapsen uinuessa tyytyväisenä liikkuvissa vaunuissa.',
                media: [
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '3AYXCEIEerruK5OERM1ShY',
                      type: 'Asset',
                      createdAt: '2020-01-09T11:34:07.130Z',
                      updatedAt: '2020-01-09T11:34:07.130Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Värejä Barcelonassa',
                      description:
                        'Barcelonassa ei arastella värien käyttöä.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 7664843,
                          image: {
                            width: 2399,
                            height: 3186
                          }
                        },
                        fileName: 'IMG_3320.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '2L8BYy7168QFQU6Pic8cHc',
                      type: 'Asset',
                      createdAt: '2020-01-09T11:35:53.733Z',
                      updatedAt: '2020-01-09T11:35:53.733Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Barcelonalainen värimaailma',
                      description:
                        'Oveen muodostuva värimaailma on hyvin barcelonalainen.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 7084989,
                          image: {
                            width: 2448,
                            height: 3264
                          }
                        },
                        fileName: 'IMG_3303.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '5qSEIQU2n0NEjIftmXIzo1',
                      type: 'Asset',
                      createdAt: '2020-01-09T11:37:27.803Z',
                      updatedAt: '2020-01-09T11:37:27.803Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Vanhakaupunki ja skootteri',
                      description:
                        'Barcelonan vanhankaupungin kapeilla kujilla skootteri on varsin näppärä kulkuväline.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 3001315,
                          image: {
                            width: 1637,
                            height: 2046
                          }
                        },
                        fileName: 'IMG_3322-1.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '3Qskc4VvgaThtbM0lbQE9',
                      type: 'Asset',
                      createdAt: '2020-01-09T11:39:00.664Z',
                      updatedAt: '2020-01-09T11:39:00.664Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Kampasimpukka',
                      description:
                        'Kampasimpukka on saanut hunnukseen kinkkumurua ja juustoa – taivaallista!\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 6145532,
                          image: {
                            width: 2448,
                            height: 3264
                          }
                        },
                        fileName: 'IMG_0659.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '35ZlWiglLZqTbBayEy92gc',
                      type: 'Asset',
                      createdAt: '2020-01-09T11:55:48.123Z',
                      updatedAt: '2020-01-09T11:55:48.123Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Anjoviksia oliiviöljypedillä ',
                      description:
                        'Anjoviksia oliiviöljypedillä – kuuluu Barcelonassa jokaiseen ateriaan!\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 5067376,
                          image: {
                            width: 2448,
                            height: 3264
                          }
                        },
                        fileName: 'IMG_3326.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  }
                ]
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '2IMwwSsOgogAW8G9J7D9TU',
                type: 'Entry',
                createdAt: '2020-01-09T12:24:20.886Z',
                updatedAt: '2020-01-09T12:24:20.886Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'experiencePhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'Jättiläisten ja isopäiden paraati',
                title:
                  'Jättiläisten ja isopäiden paraati oli ikimuistoinen kokemus',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '4DgNRvre7ZI10s2DnMNK6P',
                    type: 'Asset',
                    createdAt: '2020-01-09T12:01:18.199Z',
                    updatedAt: '2020-01-09T12:01:18.199Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Väenpaljous',
                    description:
                      'Tapahtumapaikalle virtasi väkeä usean korttelin matkalta.\n',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 5046204,
                        image: {
                          width: 2397,
                          height: 3198
                        }
                      },
                      fileName: 'IMG_1102.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Yksi matkamme kohokohdista oli La Mercé, Barcelonan suurin kaupunkijuhla, jota vietetään vuosittain 24.9. Me olimme haaveilleet perinteisestä “jättiläisten ja isopäiden” kulkueesta jo pitkään, joten matkamme ajankohta vahvistui lopulta Mercé-juhlan mukaan. Olimme ottaneet etukäteen selvää, missä ja mihin aikaan jättiläiset tanssisivat ja päättäneet suoriutua pelipaikoille hyvissä ajoin. Mikä olikin helpommin sanottu kuin tehty, sillä vanhankaupungin sokkeloinen keskusta oli kuin puulla päähän lyöty jo tunteja ennen h-hetkeä. Mutta emme lannistuneet! \n\nRaahauduimme sinnikkäästi matkarattaiden ja kantorepussa päiväuniaan torkkuvan vauvan kanssa väkijoukkojen läpi kohti goottilaisen kaupunginosan sydämessä sijaitsevaa Sant Jaumen aukiota, jolla jättiläiset näyttäytyisivät hetkenä minä hyvänsä. Ja ehdimme paikalle juuri parahiksi!\n\nEmme viihdy väentungoksissa, mutta tällä kertaa pieni epämukavuus kannatti. Kulkue oli upea! Vauvakin heräsi kantorepustaan ja ihasteli ihmismassan ylle kohonneita jättiläisiä vuoroin äidin, vuoroin isän sylistä. Tovin kulkuetta seurattuamme päätimme liueta väljemmille vesille ja antaa tilaa seuraaville. Myhäilimme tyytyväisinä – olimme jälleen yhtä ikimuistoista kokemusta rikkaampia.\n\nKulkueen jälkeen treffasimme paikalliset tuttavamme, joiden kanssa kiertelimme Ciutadella-puiston kylkeen rakennettua festivaalialuetta ruokakojuineen ja taide-esityksineen. Barcelonalaiset ne osaavat juhlia!',
                media: [
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '4cwBhJs3C0g0DDFxDx5fum',
                      type: 'Asset',
                      createdAt: '2020-01-09T12:04:27.612Z',
                      updatedAt: '2020-01-09T12:04:27.612Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Jättiläisten ja isopäiden kulkuetta.',
                      description:
                        'Puoli Barcelonaa oli kerääntynyt seuraamaan jättiläisten ja isopäiden kulkuetta.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 7600883,
                          image: {
                            width: 3264,
                            height: 2448
                          }
                        },
                        fileName: 'IMG_3281.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '6lH6RGl3fJq3VQCyQLc7Uk',
                      type: 'Asset',
                      createdAt: '2020-01-09T12:07:04.000Z',
                      updatedAt: '2020-01-09T12:07:04.000Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Vauva katsoo kantorepusta',
                      description:
                        'Vauva seurasi kiinnostuneena kantorepustaan niin jättiläisten kuin juhlaväenkin edesottamuksia.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 12275324,
                          image: {
                            width: 3456,
                            height: 5005
                          }
                        },
                        fileName: 'IMG_0952.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '1vdVXvTpZ45mhIEplrDOFC',
                      type: 'Asset',
                      createdAt: '2020-01-09T12:09:11.948Z',
                      updatedAt: '2020-01-09T12:09:11.948Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Isopäiset jättiläiset tanssivat',
                      description:
                        'Isopäiset jättiläiset tanssivat Sant Jaumen aukiolla.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 14574325,
                          image: {
                            width: 3403,
                            height: 5105
                          }
                        },
                        fileName: 'IMG_0973.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '3gXgeUIoPVToV6qOj9DhXt',
                      type: 'Asset',
                      createdAt: '2020-01-09T12:11:14.829Z',
                      updatedAt: '2020-01-09T12:11:14.829Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Ystävien kanssa',
                      description:
                        'Jättiläisten ja isopäiden kulkueen jälkeen lähdimme ystävien kanssa tutustumaan muuhun festivaalitarjontaan.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 12184071,
                          image: {
                            width: 3456,
                            height: 5184
                          }
                        },
                        fileName: 'IMG_0979.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '6xek4fWOx4Poi4b3CbwhkS',
                      type: 'Asset',
                      createdAt: '2020-01-09T12:18:35.346Z',
                      updatedAt: '2020-01-09T12:18:35.346Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Barcelonan Riemukaari',
                      description:
                        'Festivaalihumua Barcelonan Riemukaaren juurella.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 14249424,
                          image: {
                            width: 4979,
                            height: 3320
                          }
                        },
                        fileName: 'IMG_0996.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '6CYaGDGN76uU0PlvtPxeVH',
                      type: 'Asset',
                      createdAt: '2020-01-09T12:20:43.747Z',
                      updatedAt: '2020-01-09T12:21:20.953Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 2,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Ruoka- ja juomakojut',
                      description:
                        'Ruoka- ja juomakojuja löytyi moneen lähtöön.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 8885228,
                          image: {
                            width: 3264,
                            height: 2448
                          }
                        },
                        fileName: 'IMG_3297.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '1gUZeO5ikLWsr8gko25UJx',
                      type: 'Asset',
                      createdAt: '2020-01-09T12:23:32.567Z',
                      updatedAt: '2020-01-09T12:23:32.567Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Ciutadella-puisto',
                      description:
                        'Festivaalialue jatkui Ciutadella-puistoon asti.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 7295893,
                          image: {
                            width: 3119,
                            height: 2339
                          }
                        },
                        fileName: 'IMG_3335.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  }
                ]
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '1PBXX1Z49hiPOazTcnu9TZ',
                type: 'Entry',
                createdAt: '2020-01-09T12:45:10.139Z',
                updatedAt: '2020-01-09T12:45:10.139Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'experiencePhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'Casa Vicens ',
                title: 'Casa Vicens on uusi Gaudí-kohde',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '2QTOorvIKu1E3CZ5C60Wf0',
                    type: 'Asset',
                    createdAt: '2020-01-09T12:30:16.862Z',
                    updatedAt: '2020-01-09T12:30:16.862Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Näyttävä rakennus',
                    description:
                      'Casa Vicens on näyttävä rakennus ulkoa ja sisältä.\n',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 18444424,
                        image: {
                          width: 5184,
                          height: 3456
                        }
                      },
                      fileName: 'IMG_1023.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Barcelona tunnetaan kenties parhaiten Antoni Gaudín modernistisista rakennelmista, joihin lukeutuvat Sagrada Familia -kirkon lisäksi muun muassa Casa Batlló, Casa Milà ja Park Güell. Kyseiset pytingit on meidän osaltamme nähty jo aikaisemmilla reissuilla, joten olimme varsin innoissamme kun kuulimme, että Gràcian kaupunginosaan on avattu uusi Gaudí-kohde: mestarin ensimmäinen suunnittelutyö Casa Vicens. Ja kylläpäs siellä viihtyi! \n\nMuita vierailijoita ei ollut juuri nimeksikään, ja vain muutaman euron lisämaksulla sai asiantuntevan opastuksen talon lukuisiin huoneisiin ja Vicensin perheen historiaan. Meillä vierailu venähti hieman aiotusta, sillä tytär esitti taas painavan vastalauseensa museokierrokselle heti sen alettua. Mutta puutarhan seesteinen tunnelma sai tytön nukahtamaan kantoreppuun, minkä jälkeen saimme kierrettyä tilat rauhassa. Ja mikäpäs siinä, ei meillä mihinkään kiire ollut. Museokäynnin jälkeen jäimme vielä toviksi kiertelemään Gràciaan, joka oli meille toistaiseksi hieman vieraampaa Barcelonaa.',
                media: [
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '5rHJY7ePyhUcZPanMgN67K',
                      type: 'Asset',
                      createdAt: '2020-01-09T12:31:37.926Z',
                      updatedAt: '2020-01-09T12:31:37.926Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Kuva: [IMG_3360]',
                      description:
                        'Lapsi ei aluksi innostunut museossa kiertelystä, joten aloitimme puutarhasta ja jatkoimme sisälle vasta kun lapsi oli nukahtanut.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 6599601,
                          image: {
                            width: 2448,
                            height: 3264
                          }
                        },
                        fileName: 'IMG_3360.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '2JpFF8GIA1Qnl6x045kteh',
                      type: 'Asset',
                      createdAt: '2020-01-09T12:33:58.686Z',
                      updatedAt: '2020-01-09T12:33:58.686Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Restauroitu Casa Vicens',
                      description:
                        'Casa Vicens on restauroitu entiseen loistoonsa. Osaavat oppaat kertoivat kiinnostavia anekdootteja menneisyydestä.',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 9540526,
                          image: {
                            width: 2448,
                            height: 3264
                          }
                        },
                        fileName: 'IMG_1129.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '3x2LLTSqDcKdNwpL6jglMH',
                      type: 'Asset',
                      createdAt: '2020-01-09T12:36:23.897Z',
                      updatedAt: '2020-01-09T12:36:23.898Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Yhteiskuva torneissa',
                      description:
                        'Kanssaturisti otti meistä yhteiskuvan yhdessä talon torneista.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 8262252,
                          image: {
                            width: 2448,
                            height: 3264
                          }
                        },
                        fileName: 'IMG_3391.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '1byuL9sc7o5kZY2xmMdbtp',
                      type: 'Asset',
                      createdAt: '2020-01-09T12:38:34.241Z',
                      updatedAt: '2020-01-09T12:38:34.241Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Gràcia',
                      description:
                        'Casa Vicens -vierailun jälkeen tutustuimme jalan Gràcian kaupunginosaan.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 18422308,
                          image: {
                            width: 3456,
                            height: 5184
                          }
                        },
                        fileName: 'IMG_1055.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '1nhEwkWMo0sOR0y5XkZ0G8',
                      type: 'Asset',
                      createdAt: '2020-01-09T12:40:30.856Z',
                      updatedAt: '2020-01-09T12:40:30.856Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Lounas aukiolla',
                      description:
                        'Päädyimme satunnaiselle aukiolle, jossa päätimme nauttia kevyen lounaan.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 18187808,
                          image: {
                            width: 5184,
                            height: 3456
                          }
                        },
                        fileName: 'IMG_1042.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '2M92ZSZnGOB6QFxmC7IfU8',
                      type: 'Asset',
                      createdAt: '2020-01-09T12:44:31.008Z',
                      updatedAt: '2020-01-09T12:44:31.008Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Barcelonalaisia tapas-herkkuja',
                      description:
                        'Barcelonalaisia tapas-herkkuja, joista ei koskaan saa tarpeekseen: pimientos de padron, croquettes ja patatas bravas.',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 6877643,
                          image: {
                            width: 3264,
                            height: 2448
                          }
                        },
                        fileName: 'IMG_1172.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  }
                ]
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '7MP3iWc3vuNzMyKEcuHKSL',
                type: 'Entry',
                createdAt: '2020-01-09T13:12:23.931Z',
                updatedAt: '2020-01-09T13:12:23.931Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'experiencePhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'Futismatsi ja illallinen',
                title:
                  'Vanhempien omaa aikaa futismatsissa ja hienolla illallisella',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '7mlcprr4AKNqkeCWHVyfoz',
                    type: 'Asset',
                    createdAt: '2020-01-09T12:48:37.681Z',
                    updatedAt: '2020-01-09T12:48:37.681Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Kuppilan kautta matsiin',
                    description:
                      'Isän oma ilta vei jalkapalloväen kansoittaman kuppilan kautta FB Barcelonan matsiin.\n',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 6549444,
                        image: {
                          width: 2448,
                          height: 3264
                        }
                      },
                      fileName: 'IMG_3271.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Olimme jo ennen matkaa sopineet aikuisten kesken, että kumpikin saisi matkalla yhden oman illan, jolloin saa tehdä mitä mieli halajaa – ilman velvollisuuksia, ilman vastuita. Puolisoni vietti oman iltansa FC Barcelonan futismatsissa ja minä olin ajatellut käyttää omani ihan vain kaupungilla haahuilemiseen ja viinillä pistäytymiseen, ehkä pieneen iltapalaan jossain Eixamplen tunnelmallisista tapasbaareista. Mutta sitten tarjoutuikin mahdollisuus tavata Barcelonassa asuvaa tuttua illallisen ääressä ja tottahan minä tartuin tähän mahdollisuuteen ilomielin! \n\nTuttava vei minut Gràciassa sijaitsevaan välimerelliseen Gut-ravintolaan, jossa nautin herkullisesta meriruuasta, hyvästä viinistä ja aikuisseurasta täysin rinnoin. Illallisen jälkeen kävelin hiljalleen “kotiin” Eixampleen ja nautin myöhäisillan tunnelmasta.',
                media: [
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '4YNBHTXeGWcm7PCbDXg8Cj',
                      type: 'Asset',
                      createdAt: '2020-01-09T12:50:16.844Z',
                      updatedAt: '2020-01-09T12:50:16.844Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Tiivistunnelmainen baari',
                      description: 'Baarissa oli tiivis tunnelma.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 5902733,
                          image: {
                            width: 3264,
                            height: 2448
                          }
                        },
                        fileName: 'IMG_3267.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '6nMarqKqHBWxMAOTL9FvEI',
                      type: 'Asset',
                      createdAt: '2020-01-09T12:51:57.619Z',
                      updatedAt: '2020-01-09T12:51:57.619Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Camp Nou -stadion',
                      description:
                        '100 000 katsojaa vetävä Camp Nou -stadion saa ensikertalaisen leuan loksahtamaan auki. On se iso!\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 9762057,
                          image: {
                            width: 3264,
                            height: 2448
                          }
                        },
                        fileName: 'IMG_3274.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '1v6gLt8qkQ5IQZWJ1fF1JT',
                      type: 'Asset',
                      createdAt: '2020-01-09T12:53:37.905Z',
                      updatedAt: '2020-01-09T12:53:37.905Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Tuliaisia Barcelonasta',
                      description:
                        'Perheen pienimmäinen sai Barcelonan-tuliaisia.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 5265201,
                          image: {
                            width: 2386,
                            height: 3206
                          }
                        },
                        fileName: 'IMG_3447.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '2f89LvwXlHld2tlU9ZUvOJ',
                      type: 'Asset',
                      createdAt: '2020-01-09T12:55:29.138Z',
                      updatedAt: '2020-01-09T12:55:29.138Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Gràcialainen aukio',
                      description:
                        'Äidin oma ilta alkoi gràcialaiselta aukiolta.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 6599079,
                          image: {
                            width: 2448,
                            height: 3264
                          }
                        },
                        fileName: 'IMG_3400.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '1DYKBVyo3zKiEQMFypCJjQ',
                      type: 'Asset',
                      createdAt: '2020-01-09T12:57:59.371Z',
                      updatedAt: '2020-01-09T12:57:59.371Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Vermutin äärellä',
                      description:
                        'Vermutin äärellä oli hauska seurata aukion elämää; paikalliset asukkaat vauvasta vaariin olivat kerääntyneet aukiolle pelaamaan jalkapalloa, lukemaan lehteä ja tapaamaan tuttavia.',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 6272269,
                          image: {
                            width: 2339,
                            height: 3119
                          }
                        },
                        fileName: 'IMG_1202.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '6IBB0zyhfnShqWtchQ1y1g',
                      type: 'Asset',
                      createdAt: '2020-01-09T12:59:32.322Z',
                      updatedAt: '2020-01-09T12:59:32.322Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Gutin simpukat',
                      description:
                        'Gutin simpukat thaimaalaiseen tapaan olivat lempeän tulisia.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 8055661,
                          image: {
                            width: 2448,
                            height: 3264
                          }
                        },
                        fileName: 'IMG_1206.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '2xN32f7t9ROVDF653BPZ05',
                      type: 'Asset',
                      createdAt: '2020-01-09T13:01:18.743Z',
                      updatedAt: '2020-01-09T13:01:18.743Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Tartar meriahvenesta ja yuzu-sorbettia',
                      description:
                        'Pääruuaksi tartar meriahvenesta ja yuzu-sorbettia.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 7109788,
                          image: {
                            width: 2448,
                            height: 3264
                          }
                        },
                        fileName: 'IMG_1207.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '5Tf8oRoqjgy6CRzd3jXUZe',
                      type: 'Asset',
                      createdAt: '2020-01-09T13:09:10.365Z',
                      updatedAt: '2020-01-09T13:09:10.365Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Jälkiruoka',
                      description: 'Jälkiruoka kruunasi loistavan aterian.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 7310101,
                          image: {
                            width: 3264,
                            height: 2448
                          }
                        },
                        fileName: 'IMG_1208.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '5xJ5eNlkhhi3G4IOLoUyKb',
                      type: 'Asset',
                      createdAt: '2020-01-09T13:10:58.649Z',
                      updatedAt: '2020-01-09T13:10:58.649Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Barcelonan yössä',
                      description: 'Anskun kanssa Barcelonan “yössä”.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 1071043,
                          image: {
                            width: 1280,
                            height: 960
                          }
                        },
                        fileName: 'IMG_1212.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  }
                ]
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '7qh7WoaaqgCEK1165NPHSt',
                type: 'Entry',
                createdAt: '2020-01-09T13:18:58.817Z',
                updatedAt: '2020-01-09T13:18:58.817Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'experiencePhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'Vermutería Colmadossa',
                title: 'Viimeinen illallinen vermutería Colmadossa',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '7akIlyRRAB0KveIQhZuWkW',
                    type: 'Asset',
                    createdAt: '2020-01-09T13:14:36.797Z',
                    updatedAt: '2020-01-09T13:14:36.797Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Talon vermut',
                    description:
                      'Aperitiiviksi tilasimme talon omaa vermuttia.\n',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 7273284,
                        image: {
                          width: 2448,
                          height: 3264
                        }
                      },
                      fileName: 'IMG_1280.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Viimeisenä iltana päätimme herkutella oikein pitkän kaavan mukaan aikaisemmilta reissuilta tutussa vermuttibaarissa Colmadossa. Olimme liikkeellä ajoissa, jotta lapsen nukkumaanmeno ei venähtäisi liiaksi, ja mahduimmekin rattaidemme hyvin sisään, sillä paikka oli laajentanut sitten edelliskerran. Tilasimme aperitiiviksi talon omaa vermuttia, jota siemaillessa katselimme ympärillemme ja aistimme paikan tunnelmaa.\n\nPian pöytäämme alkoi virrata herkkuja toisensa perään: anjoviksia oliiviöljyssä, valkoviinissä haudutettua mausteista chistorra-makkaraa, mustekalaa perunapedillä, erilaisia kinkkuja ja juustoja… Olimme varmuuden vuoksi tilanneet lähes koko listan läpi, ettei mitään hyvää jäisi vahingossa maistamatta. Palanpainikkeeksi vielä lasillinen hyvää punaviiniä – mitä sitä muuta ihminen lomallaan tarvitsee.\n\nParin pöydän päässä istui pariskunta samanikäisen vauvan kanssa. Olimme nyökänneet toisillemme yhteisymmärryksen merkiksi jo ravintolaan saapuessamme, ja ilmeisesti myös vauvat olivat pistäneet toisensa merkille. Kuin yhteisestä sopimuksesta he nimittäin päättivät, että ravintolassa istuminen ja seurustelu on tylsintä maailmassa, joten pian molempien seurueiden miehet olivatkin kadulla kärryttelemässä vauvoja unten maille. Me naiset loimme toisiimme ymmärtävän katseen ja kohotimme lasejamme. “Barcelonalle!”',
                media: [
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '5XIPFC5P9c7TAm0zP6K0kh',
                      type: 'Asset',
                      createdAt: '2020-01-09T13:16:48.043Z',
                      updatedAt: '2020-01-09T13:16:48.043Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Colmadon kinkut ja juustot ',
                      description:
                        'Colmadon kinkut ja juustot olivat ensiluokkaisia.\n',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 6567103,
                          image: {
                            width: 2448,
                            height: 3165
                          }
                        },
                        fileName: 'IMG_1281.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '7muxloLmqw7QgRySVK6r2n',
                      type: 'Asset',
                      createdAt: '2020-01-09T13:18:27.486Z',
                      updatedAt: '2020-01-09T13:18:27.486Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Mustekalaa perunapedillä ',
                      description:
                        'Pulpo a la gallega eli mustekalaa perunapedillä on annos, jota me emme jätä tilaamatta, jos siihen vain tarjoutuu mahdollisuus. Parasta.',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 5717789,
                          image: {
                            width: 3264,
                            height: 2448
                          }
                        },
                        fileName: 'IMG_1286.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  }
                ]
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: 'XUFD8uY8udZhvM7Zuk2wD',
                type: 'Entry',
                createdAt: '2020-01-09T13:35:18.632Z',
                updatedAt: '2020-01-09T13:35:18.632Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'travelPhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'Loistava valinta matkakohteeksi',
                title:
                  'Barcelona oli loistava valinta vauvan ensimmäiseksi matkakohteeksi',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: 'JdH8hwLc8Y489qccWEBsf',
                    type: 'Asset',
                    createdAt: '2020-01-09T13:35:11.046Z',
                    updatedAt: '2020-01-09T13:35:11.046Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Maisemat Barcelonassa',
                    description:
                      'Barcelonan maisemat jäivät muistoihin kotiinlähdön myötä.',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 7295893,
                        image: {
                          width: 3119,
                          height: 2339
                        }
                      },
                      fileName: 'IMG_3335.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Barcelona osoittautui ehdottoman lapsiystävälliseksi kaupungiksi! Siellä ei tarvinnut erikseen miettiä, voiko jonnekin mennä lapsen kanssa – kaikkialle voi. Vielä tällä kertaa meidän ei tarvinnut etsiä erityisesti lapsia kiinnostavia aktiviteetteja, mutta ehkä jo seuraavalla reissulla on niiden aika.\n \nParasta tällä matkalla oli kiireettömyys ja perheen yhteinen aika. Emme ottaneet\npaineita pakollisista nähtävyyksistä, sillä ne oli jo nähty, vaan pyhitimme lomaviikkomme kuljeskelulle, nautiskelulle ja uuden löytämiselle. Sekä pitkille aamiaisille, lounaille ja yöunille.\n \nBarcelonalla on sydämissämme aivan erityinen paikka ja tiedämme palaavamme sinne vielä useasti.'
              }
            }
          ],
          destinations: [
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '788g3WIRK24kSrkYGOlVLX',
                type: 'Entry',
                createdAt: '2020-01-09T13:43:24.019Z',
                updatedAt: '2020-01-09T13:43:24.019Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'destination'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                title: 'Barcelona',
                slug: 'barcelona',
                mainImage: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '1OaDX27jIEzN2qYsapJxpG',
                    type: 'Asset',
                    createdAt: '2020-01-09T13:42:39.999Z',
                    updatedAt: '2020-01-09T13:42:55.754Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 2,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Barcelona',
                    description: 'Barcelona, Espanja',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 26776,
                        image: {
                          width: 300,
                          height: 200
                        }
                      },
                      fileName: 'barcelona-espanja-019-300x200.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                country: 'Espanja',
                cityErpId: 1407,
                leadParagraph: 'TBD',
                description: 'TBD',
                trips: [
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '3CGT8DM1fF9WYt9wY87JKj',
                      type: 'Entry',
                      createdAt: '2020-01-09T13:39:36.059Z',
                      updatedAt: '2020-01-09T13:39:36.059Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: 'Link',
                          linkType: 'ContentType',
                          id: 'trip'
                        }
                      },
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Barcelonan kaupunkiloma',
                      erpTripId: 1010
                    }
                  }
                ]
              }
            }
          ]
        }
      },
      {
        sys: {
          space: {
            sys: {
              type: 'Link',
              linkType: 'Space',
              id: 'bh7k0sgo84rb'
            }
          },
          id: '3FKaaG2suT64PRVLy5JOS0',
          type: 'Entry',
          createdAt: '2020-01-08T11:56:32.471Z',
          updatedAt: '2020-01-09T09:45:28.351Z',
          environment: {
            sys: {
              id: 'sandbox1',
              type: 'Link',
              linkType: 'Environment'
            }
          },
          revision: 2,
          contentType: {
            sys: {
              type: 'Link',
              linkType: 'ContentType',
              id: 'memory'
            }
          },
          locale: 'fi-FI'
        },
        fields: {
          title: 'Maisemia ja meriahventa Sorrentossa',
          slug: 'maisemia-ja-meriahventa-sorrentossa',
          leadParagraph:
            'Kesäinen lämpö, kauniit maisemat, rento eteläitalialainen tunnelma ja taivaallinen ruoka! Niitä lähdemme vaimon ja kahden alakouluikäisen tyttären kanssa syyslomaviikolta hakemaan. Valitsimme kohteeksemme Sorrenton ja päiväretkikohteet sen ympäristössä. Tuo seutu oli jäänyt meiltä lukuisista Italian-matkoista huolimatta vielä näkemättä.',
          trip: {
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'bh7k0sgo84rb'
                }
              },
              id: '6OntZ3jB94vXo0JCoIabRK',
              type: 'Entry',
              createdAt: '2020-01-09T08:53:06.564Z',
              updatedAt: '2020-01-09T08:53:06.564Z',
              environment: {
                sys: {
                  id: 'sandbox1',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'trip'
                }
              },
              locale: 'fi-FI'
            },
            fields: {
              title: 'Testimatka',
              erpTripId: 0
            }
          },
          mainImage: {
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'bh7k0sgo84rb'
                }
              },
              id: '4iYGxMMMYlLYOysRPUfY9q',
              type: 'Asset',
              createdAt: '2020-01-08T11:37:10.301Z',
              updatedAt: '2020-01-08T11:37:10.301Z',
              environment: {
                sys: {
                  id: 'sandbox1',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              revision: 1,
              locale: 'fi-FI'
            },
            fields: {
              title: 'Marina Grande ',
              description:
                'Tunnelmallinen Marina Grande näyttää edelleen miltei samalta kuin Sophia Lorenin tähdittämässä mustavalkoisessa elokuvassa.',
              file: {
                url: '//localhost:3000/static/test/dummy-image.png',
                details: {
                  size: 20376165,
                  image: {
                    width: 6000,
                    height: 4000
                  }
                },
                fileName: 'MarinaGrande.jpg',
                contentType: 'image/jpeg'
              }
            }
          },
          startDate: '2019-10-15',
          endDate: '2019-10-22',
          travellers: [
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: 'F6bquFyyNyPMTdT2rhbpw',
                type: 'Entry',
                createdAt: '2020-01-08T11:21:36.380Z',
                updatedAt: '2020-01-08T11:21:36.380Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'traveller'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                profilePicture: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '593NbSsHdlZ3NPfKucrOpw',
                    type: 'Asset',
                    createdAt: '2020-01-08T11:21:09.496Z',
                    updatedAt: '2020-01-08T11:21:09.496Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Mika Väistö',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 7789345,
                        image: {
                          width: 4288,
                          height: 2848
                        }
                      },
                      fileName: 'Marina_Piccola_Sorrento_2009_3636040095.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                title: 'Mika Väistö',
                firstName: 'Mika',
                slug: 'mika-vaisto',
                shortInfo: 'Matkustaa perheen kanssa.',
                residence: 'Helsinki',
                leadParagraph: '-'
              }
            }
          ],
          phases: [
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '66eYC4UbdHGFooDhJDuLyq',
                type: 'Entry',
                createdAt: '2020-01-08T11:35:38.458Z',
                updatedAt: '2020-01-08T11:35:38.458Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'travelPhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'Autostrada',
                title: 'Kiitää alla autostrada',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '3gMV6JroiG2yEuo22bMyED',
                    type: 'Asset',
                    createdAt: '2020-01-08T11:35:12.355Z',
                    updatedAt: '2020-01-08T11:35:12.355Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Rannikkomaisema',
                    description:
                      'Sorrenton niemen rantajyrkänteillä kiemurtelevalta tieltä voi ihailla huikeita maisemia.\n',
                    file: {
                      url:
                        '//downloads.ctfassets.net/bh7k0sgo84rb/3gMV6JroiG2yEuo22bMyED/de7c9f7cc57916cda557c7e4c1ef9e21/Rannikkomaisema.jpg',
                      details: {
                        size: 22363080,
                        image: {
                          width: 6000,
                          height: 4000
                        }
                      },
                      fileName: 'Rannikkomaisema.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Arjen kiireet unohtuvat jo lentokoneessa, kun katselen alla vaihtuvia maisemia. Majoitumme ensimmäiseksi yöksi Rooman lähistölle ja jatkamme seuraavana aamuna kohti etelää. Aurinko paistaa autostradalla vuokra-auton tuulilasiin ja radiossa soivat italialaiset hitit. Innostus nousee huippuunsa Sorrenton lähestyessä, kun pysähdymme ihailemaan rantajyrkänteiden päältä avautuvia merimaisemia.'
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '1WPNKYautFIcMpypQNjvSR',
                type: 'Entry',
                createdAt: '2020-01-08T11:43:42.086Z',
                updatedAt: '2020-01-09T09:46:04.463Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 2,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'hotelPhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'B&B Les Chic',
                title: 'Mustan kissan majatalo',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '2LdET4ZepPX03mGbWkNk3C',
                    type: 'Asset',
                    createdAt: '2020-01-08T11:42:43.382Z',
                    updatedAt: '2020-01-08T11:42:43.382Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Majatalon pihamaan kissa',
                    description:
                      'Lapset ihastuivat majapaikkamme pihalla asustaneeseen kissaan.',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 8603283,
                        image: {
                          width: 4032,
                          height: 3024
                        }
                      },
                      fileName: 'Kissa.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Sorrentossa meidät ottaa vastaan majapaikkamme pihamaalla viihtyvä kissa. Lapset ihastuvat siihen välittömästi, ja uusi mustaturkkinen ystävä ilahduttaa meitä joka päivä ohi kulkiessamme. Yövymme B&B Les Chicissa, joka sijaitsee kätevästi rautatieaseman vieressä. Maisema ei ole maailman romanttisin, mutta huoneemme parvekkeesta tulee meille silti mieluisa paikka. Ohi kiitävien skootterien pärinää kuunnellessa voi kuvitella asuvansa italialaisessa kaupungissa ja samalla kertailla päivän tapahtumia: kuinka söimme aitoa napolilaista pizzaa, hämmästelimme Pompejin raunioiden laajuutta, huokailimme Amalfin rannikon kauneutta tai eksyimme Caprin kujille.',
                media: [
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '5H36uXvwTOPzyknixEcZnA',
                      type: 'Asset',
                      createdAt: '2020-01-08T11:52:14.882Z',
                      updatedAt: '2020-01-08T11:52:14.882Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Parvekenäkymä majapaikasta',
                      description:
                        'Majapaikkamme parvekenäkymä oli arkinen, mutta nautimme paikallisen elämän seuraamisesta.',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 11820660,
                          image: {
                            width: 3024,
                            height: 4032
                          }
                        },
                        fileName:
                          'Majapaikkamme-parvekenäkymä-oli-arkinen,-mutta-nautimme-paikallisen-elämän-seuraamisesta.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  }
                ]
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '7txVjZrVVpm1dgqfpqQGrk',
                type: 'Entry',
                createdAt: '2020-01-08T11:46:18.496Z',
                updatedAt: '2020-01-09T09:46:24.439Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 2,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'experiencePhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'Kalasatama',
                title: 'Kalastussataman tunnelmaa',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '2iUBPycL0daYp10aoQHixL',
                    type: 'Asset',
                    createdAt: '2020-01-08T11:46:06.311Z',
                    updatedAt: '2020-01-08T11:46:06.311Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Kalaruoka',
                    description:
                      'Kalaruoka maistuu parhaalta kiireettömästi meren äärellä nautittuna.\n',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 10666588,
                        image: {
                          width: 4032,
                          height: 3024
                        }
                      },
                      fileName: 'TrattoriaEmilia.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Kevyt merituuli viilentää helteistä päivää, veneet lepäävät laiturissa ja lasissa on tilkka valkoviiniä. Pian pöytä alkaa täyttyä mehevistä tomaateista, mozzarellasta, tuoreesta kalasta sekä muista merenelävistä. Kaipaamme ravintolaelämyksiltämme erityisesti ruudullisia pöytäliinoja sekä sellaista ruokaa, joka voisi olla italialaisen isoäidin keittiöstä. Täällä isoäidin nimi on Emilia, ja hänen mukaansa nimetty trattoria on toiminut kalastussatama Marina Grandessa jo vuosikymmeniä.\n\nPäädyimme juuri tähän trattoriaan majapaikkamme isännän suosituksesta, ja olemme tyytyväisiä niin ruokaan kuin ympäristöönkin. Satama on nimestään huolimatta pieni ja siellä vallitsee leppoisan vanhanaikainen tunnelma. Lapsilla ei kuulemma ollut edes nälkä, mutta mustekalarenkaat ja meriahven katoavat nopeasti parempiin suihin. Kiireetön tunnelma saa särön vasta, kun tytöt muistavat pääsevänsä seuraavaksi uimaan.\n',
                media: [
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '3HU2Hbmcky2rivmdZGkkDV',
                      type: 'Asset',
                      createdAt: '2020-01-08T11:54:09.530Z',
                      updatedAt: '2020-01-08T11:54:09.530Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Marina Granden veneet',
                      description:
                        'Marina Granden veneiden takana siintää Napolinlahden vastarantaa hallitseva Vesuvius.',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 17061155,
                          image: {
                            width: 6000,
                            height: 4000
                          }
                        },
                        fileName:
                          'Marina-Granden-veneiden-takana-siintää-Napolinlahden-vastarantaa-hallitseva-Vesuvius.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  }
                ]
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: 'Qc5L1nFo3rOF822EF5T9w',
                type: 'Entry',
                createdAt: '2020-01-08T11:49:40.862Z',
                updatedAt: '2020-01-08T11:49:40.862Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'travelPhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'Rukoilla ja pyytää',
                title: 'Sua rukoilen ja pyydän...',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '1sPUAUS6qZGP45QSo0Mbnd',
                    type: 'Asset',
                    createdAt: '2020-01-08T11:49:34.495Z',
                    updatedAt: '2020-01-08T11:49:34.495Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Italialaista jäätelöä',
                    description:
                      'Päivittäinen jäätelö kuuluu Italian matkan iloihin.',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 7782984,
                        image: {
                          width: 3024,
                          height: 4032
                        }
                      },
                      fileName:
                        'Päivittäinen-jäätelö-kuuluu-Italian-matkan-iloihin.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Viikkoomme sisältyi upeita elämyksiä, satoja maisemakuvia, kiireettömiä hetkiä sekä monta herkullista jäätelöä. Minusta tuntuu, että vielä joskus vastaamme vanhassa laulussa rukoillen esitettyyn pyyntöön ja “palajamme Sorrentohon”!'
              }
            }
          ],
          destinations: [
            {
              sys: {
                type: 'Link',
                linkType: 'Entry',
                id: '1ZVy7x0SUMZQCF9yEFT2mx'
              }
            }
          ]
        }
      },
      {
        sys: {
          space: {
            sys: {
              type: 'Link',
              linkType: 'Space',
              id: 'bh7k0sgo84rb'
            }
          },
          id: '59TGdoPrgQeUkY2HocGgI5',
          type: 'Entry',
          createdAt: '2020-01-08T14:10:06.730Z',
          updatedAt: '2020-01-08T14:10:06.730Z',
          environment: {
            sys: {
              id: 'sandbox1',
              type: 'Link',
              linkType: 'Environment'
            }
          },
          revision: 1,
          contentType: {
            sys: {
              type: 'Link',
              linkType: 'ContentType',
              id: 'memory'
            }
          },
          locale: 'fi-FI'
        },
        fields: {
          title: 'Jokiristeilyllä Lontoossa',
          slug: 'jokiristeilylla-lontoossa',
          leadParagraph:
            'Lontoo on aina hyvä idea! Näin tuumimme mieheni kanssa, kun valitsimme kohdetta pitkäksi viikonlopuksi lokakuulle. Lontoo oli meille entuudestaan tuttu kaupunki. Edellisestä reissusta oli viisi vuotta, joten oli aika mennä katsomaan mitä uutta suurkaupungilla olisi tarjota.\n',
          trip: {
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'bh7k0sgo84rb'
                }
              },
              id: '6uwJEFzhG1XI8xTYDsI7BH',
              type: 'Entry',
              createdAt: '2020-01-08T14:08:31.214Z',
              updatedAt: '2020-01-08T14:08:31.214Z',
              environment: {
                sys: {
                  id: 'sandbox1',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'trip'
                }
              },
              locale: 'fi-FI'
            },
            fields: {
              title: 'Lontoon kaupunkiloma',
              erpTripId: 842
            }
          },
          mainImage: {
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'bh7k0sgo84rb'
                }
              },
              id: '3rZScgpDCZKlUP5Z3cnDjC',
              type: 'Asset',
              createdAt: '2020-01-08T13:59:39.405Z',
              updatedAt: '2020-01-08T13:59:39.405Z',
              environment: {
                sys: {
                  id: 'sandbox1',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              revision: 1,
              locale: 'fi-FI'
            },
            fields: {
              title: 'Thamesin-jokiristeily London-eye',
              description:
                'Thamesin jokiristeilyllä voi myös nähdä voi nähdä mahtavan London Eyen.',
              file: {
                url: '//localhost:3000/static/test/dummy-image.png',
                details: {
                  size: 13497115,
                  image: {
                    width: 4608,
                    height: 3456
                  }
                },
                fileName: 'Thamesin-jokiristeily_London-eye.jpg',
                contentType: 'image/jpeg'
              }
            }
          },
          startDate: '2019-11-01',
          endDate: '2020-01-05',
          travellers: [
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '1wzc3ckQtYUZSyruIccQFm',
                type: 'Entry',
                createdAt: '2020-01-08T13:35:54.186Z',
                updatedAt: '2020-01-08T13:35:54.186Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'traveller'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                profilePicture: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '2rYvvDd8iHONx6UQoiW8Y5',
                    type: 'Asset',
                    createdAt: '2020-01-08T13:35:49.233Z',
                    updatedAt: '2020-01-08T13:35:49.234Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Merja Kukkonen',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 71253,
                        image: {
                          width: 640,
                          height: 427
                        }
                      },
                      fileName: '_MG_7126',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                title: 'Merja Kukkonen',
                firstName: 'Merja',
                slug: 'merja-kukkonen',
                shortInfo: 'Matkustaa puolisonsa kanssa',
                residence: 'Helsinki',
                leadParagraph: '-'
              }
            }
          ],
          phases: [
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '19Ynri0mkPAClBcVxX1RvU',
                type: 'Entry',
                createdAt: '2020-01-08T13:41:01.092Z',
                updatedAt: '2020-01-08T13:41:01.092Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'travelPhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'Iltalento Lontooseen',
                title: 'Iltalennolla Lontooseen',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '12hx1MdaYR1sk8YiCySiaY',
                    type: 'Asset',
                    createdAt: '2020-01-08T13:39:52.829Z',
                    updatedAt: '2020-01-08T13:39:52.829Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Lontoon yllä',
                    description:
                      'Lontoon valtavan koon näkee lentokoneesta käsin.',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 9076306,
                        image: {
                          width: 3024,
                          height: 4032
                        }
                      },
                      fileName: 'Lontoon-ylla.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Matka alkoi mukavasti perjantaina iltapäivällä Finnairin loungessa nauttien pientä syötävää ja juotavaa. Minilomalle piti ehdottomasti skoolata! Olin upgreidannut meidät pisteillä businessluokkaan, joten pieni ylellisyyden tunne jatkui lentokoneessa. Heathrowin lentokentältä ostimme pankkikortin lähimaksulla liput metroon ja yhdellä vaihdolla pääsimme lähelle hotellia, joka sijaitsi lähellä Tower Bridgeä.\n'
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '4DDDLZ1yj9PyR9avKbBmC5',
                type: 'Entry',
                createdAt: '2020-01-08T13:45:17.020Z',
                updatedAt: '2020-01-08T13:45:17.020Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'hotelPhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'The Chamberlain',
                title: 'Viihtyisä The Chamberlain -hotelli',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '6D363KJ4CoSbItddXWF0uV',
                    type: 'Asset',
                    createdAt: '2020-01-08T13:43:36.123Z',
                    updatedAt: '2020-01-08T13:44:21.887Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 2,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Miellyttävät värisävyt',
                    description:
                      'The Chamberlain -hotellin värisävyt miellyttivät silmää.',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 11690870,
                        image: {
                          width: 4608,
                          height: 3456
                        }
                      },
                      fileName: 'IMG_3656.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Edellisellä matkalla majoituimme kahden tähden hotelliin, jonka huoneen katossa oli homeläikkiä. Tällä kertaa halusin parempaa ja valinta osui The Chamberlainiin, joka olikin oikein viihtyisä. Huone oli iso ja modernisti sisustettu. Sängyn muhkeat peitot pitivät huolen, ettei kylmä tullut, vaikka huoneessa oli viileää. Minibaarin antimet kuuluivat huoneen hintaan ja sieltä löytyi vesipullojen lisäksi olutta sekä virvokkeita.'
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '1naQhQyIqxaYB1JWhLSFYR',
                type: 'Entry',
                createdAt: '2020-01-08T13:50:24.957Z',
                updatedAt: '2020-01-08T13:50:24.957Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'experiencePhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'Thames-joki',
                title: 'Nähtävyyksiä Thames-joelta käsin',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '0nfLmP5Ih5XCj2hg4JoHx',
                    type: 'Asset',
                    createdAt: '2020-01-08T13:50:18.152Z',
                    updatedAt: '2020-01-08T13:50:18.152Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Tower Bridge',
                    description:
                      'Tower Bridge kohosi komeana eteemme jokiristeilyllä.',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 10547908,
                        image: {
                          width: 4608,
                          height: 3201
                        }
                      },
                      fileName: 'IMG_3743.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Lauantaille olimme suunnitelleet Thamesin jokiristeilyä, jos sää suosisi. Koska päivä näytti aurinkoiselta, suuntasimme Buckinghamin palatsin kautta Westminister Pierille, josta jokilaivat lähtivät. Ostimme liput Greenwichiin ja juoksimme viimeisten joukossa laivaan. Parhaimmat paikat oli jo vallattu, mutta tunnin risteily sujui ilman istumapaikkaakin. Mies kävi ostamassa meille oluet ja niitä hörppiessä katselimme nähtävyyksiä ja kuuntelimme oppaan selostusta. Opas oli huumorintajuinen ja aloitti puheensa sanomalla ”en tiedä kuinka moni teistä ymmärtää minua, mutta toivottavasti edes joku”. Hän oli huomannut risteilyväen koostuvan isoista turistiryhmistä. \n\nAurinkoinen ja lokakuuhun nähden lämmin sää teki olon suorastaan riehakkaaksi ja kirmailin kamerani kanssa edestakaisin tallentaen nähtävyyksiä joelta käsin. Kun tunnin kuluttua lähestyimme Greenwichin laituria, harmitti että risteily oli loppumaisillaan. Miniloma oli kuitenkin vasta alussa ja Greenwichissä meitä odotti herkullinen lounas sekä mielenkiintoinen merimuseo.'
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '6TGuZHog4BMFA4Zhgr0SEX',
                type: 'Entry',
                createdAt: '2020-01-08T13:56:39.334Z',
                updatedAt: '2020-01-08T13:56:39.334Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'travelPhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'Piristystä Lontoosta',
                title: 'Lontoo toi piristystä arkeen',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '3Rdbwruj4C8dFizOKwenLQ',
                    type: 'Asset',
                    createdAt: '2020-01-08T13:56:34.451Z',
                    updatedAt: '2020-01-08T13:56:34.451Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Merja puhelinkopissa',
                    description: '“Hello, London calling”.',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 1368340,
                        image: {
                          width: 1039,
                          height: 1386
                        }
                      },
                      fileName: 'Merja-puhelinkopissa.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Lontoon matka oli oikein onnistunut. Pääsin toivomalleni jokiristeilylle, hotellivalinta osui nappiin ja ehdimme viikonlopun aikana nähdä paljon kaikenlaista. Reppuun sujahti taas monta mukavaa muistoa tältä matkalta.\n \n\nLontoon matka oli oikein onnistunut. Pääsin toivomalleni jokiristeilylle, hotellivalinta osui nappiin ja ehdimme viikonlopun aikana nähdä paljon kaikenlaista. Reppuun sujahti taas monta mukavaa muistoa tältä matkalta.\n '
              }
            }
          ],
          destinations: [
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '5t6CErZ2t6qjwmaXhYLRr5',
                type: 'Entry',
                createdAt: '2020-01-08T14:07:46.742Z',
                updatedAt: '2020-01-08T14:07:46.742Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'destination'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                title: 'Lontoo',
                slug: 'lontoo',
                mainImage: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '5Of3lkpLzFdF0eQQBbpa4C',
                    type: 'Asset',
                    createdAt: '2020-01-08T14:06:11.705Z',
                    updatedAt: '2020-01-08T14:06:37.568Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 2,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Lontoo',
                    description: 'Lontoo, Iso-Britannia',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 19552,
                        image: {
                          width: 300,
                          height: 200
                        }
                      },
                      fileName: 'lontoo-iso-britannia-011-300x200.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                country: 'Iso-Britannia',
                cityErpId: 121,
                leadParagraph: 'TBD',
                description: 'TBD',
                trips: [
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '1cDN9awTJ1vylAYpnSJFg9',
                      type: 'Entry',
                      createdAt: '2020-01-08T14:07:34.996Z',
                      updatedAt: '2020-01-08T14:07:34.996Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: 'Link',
                          linkType: 'ContentType',
                          id: 'trip'
                        }
                      },
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Lontoon kaupunkiloma',
                      erpTripId: 842
                    }
                  }
                ]
              }
            }
          ]
        }
      },
      {
        sys: {
          space: {
            sys: {
              type: 'Link',
              linkType: 'Space',
              id: 'bh7k0sgo84rb'
            }
          },
          id: '3U2UgE1o8N0pWCWim9dXYT',
          type: 'Entry',
          createdAt: '2019-12-30T10:56:20.937Z',
          updatedAt: '2019-12-30T10:56:20.937Z',
          environment: {
            sys: {
              id: 'sandbox1',
              type: 'Link',
              linkType: 'Environment'
            }
          },
          revision: 1,
          contentType: {
            sys: {
              type: 'Link',
              linkType: 'ContentType',
              id: 'memory'
            }
          },
          locale: 'fi-FI'
        },
        fields: {
          title: 'Tapaksia ja trendibaareja Madridissa',
          slug: 'tapaksia-ja-trendibaareja-madridissa',
          leadParagraph:
            'Joskus sitä kaipaa reissulta nähtävyyksien sijaan vain hyvää ruokaa – ja parhaan ystävän seuraa. Herkullisista tapaksista, viinistä ja vermutista ei tällä viikonloppureissulla todellakaan ollut pulaa.',
          trip: {
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'bh7k0sgo84rb'
                }
              },
              id: '3sJFzGhRJnbsurRvQknnTZ',
              type: 'Entry',
              createdAt: '2019-12-30T09:27:23.900Z',
              updatedAt: '2019-12-30T09:27:23.900Z',
              environment: {
                sys: {
                  id: 'sandbox1',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'trip'
                }
              },
              locale: 'fi-FI'
            },
            fields: {
              title: 'Madridin kaupunkiloma',
              erpTripId: 1
            }
          },
          mainImage: {
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'bh7k0sgo84rb'
                }
              },
              id: '1SHmivJdIlTxAF8tFcRsjj',
              type: 'Asset',
              createdAt: '2019-12-30T10:42:59.578Z',
              updatedAt: '2020-01-03T13:06:35.419Z',
              environment: {
                sys: {
                  id: 'sandbox1',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              revision: 3,
              locale: 'fi-FI'
            },
            fields: {
              title: 'Casa Camacho, Madrid',
              description:
                ' Casa Camacho on koko kaupungin tunnetuin vermutería. Kuva: Tuulia Kolehmainen.',
              file: {
                url: '//localhost:3000/static/test/dummy-image.png',
                details: {
                  size: 7349838,
                  image: {
                    width: 4819,
                    height: 2453
                  }
                },
                fileName:
                  'Casa Camacho on koko kaupungin tunnetuin vermutería.jpg',
                contentType: 'image/jpeg'
              }
            }
          },
          startDate: '2018-08-09',
          endDate: '2018-08-11',
          travellers: [
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '44jb1T0RX3KgQTXNqwKjfb',
                type: 'Entry',
                createdAt: '2019-12-30T10:49:53.333Z',
                updatedAt: '2020-01-10T09:57:56.061Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 2,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'traveller'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                profilePicture: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '6own4qgCFiDcwRPBxSrznE',
                    type: 'Asset',
                    createdAt: '2019-12-30T09:37:49.041Z',
                    updatedAt: '2019-12-30T09:37:49.041Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Paula Kultanen Ribas',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 19380,
                        image: {
                          width: 320,
                          height: 320
                        }
                      },
                      fileName: 'paulakulta.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                title: 'Paula Kultanen Ribas',
                firstName: 'Paula',
                slug: 'paula-kultanen-ribas',
                shortInfo: 'Espanjan rentoutta rakastava blondi basisti',
                residence: 'Helsinki',
                instagramHandle: 'paulakulta',
                homepage: {
                  sys: {
                    type: 'Link',
                    linkType: 'Entry',
                    id: '3KmMKLk6lzwBvuXhnBieTm'
                  }
                },
                leadParagraph:
                  'Kun matkustan, haluan tuntea olevani kuin kotonani, kuin paikallinen. Asuin pitkään\nBarcelonassa ja espanja on toinen kotikieleni, siksi Espanja on lähimpänä sydäntä.\nMatkaillessa tärkeintä on autenttisten, paikallisten suosimien paikkojen bongailu, hyvä\nruoka, juoma, festarit ja keikat sekä kiinnostavat museot, näyttelyt ja kohteen historia.'
              }
            }
          ],
          phases: [
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: 'k9mvo8mWC7VKWQT60eSDS',
                type: 'Entry',
                createdAt: '2019-12-30T10:45:42.239Z',
                updatedAt: '2019-12-30T10:45:42.239Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'travelPhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'Helsinki - Madrid',
                title: 'Aamulennolla Madridiin ja metrolla hotellille',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '4gpNTp5WRdovB8xt1nqbrF',
                    type: 'Asset',
                    createdAt: '2019-12-30T09:46:39.072Z',
                    updatedAt: '2019-12-30T09:46:39.072Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Wine and View',
                    description:
                      'Matka kilistellään alkaneeksi Helsinki-Vantaalla, maailman parhaaksi lentokenttäbaariksi valitussa Wine & View’ssä. Kuva: Tuulia Kolehmainen.',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 1196483,
                        image: {
                          width: 1920,
                          height: 1280
                        }
                      },
                      fileName: '1. Wine_and_View_MG_6146.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Lentoajankohdaksi valikoitui aamu, koska neljän ja puolen tunnin lennon jälkeenkin Madridissa on yhä lounasaika, sí señor!\n \nBarajasin lentokentällä kuulimme, että Madridissa oli juuri alkanut taksilakko. Mutta eipä hätiä: neuvokkaina muijina otimme metron Nuevos Ministerios -pysäkille ja hurautimme vaihdon jälkeen pääteasemallemme Plaza Españalle, josta kävelymatkaa hotellille oli alle kymmenen minuuttia. Painavien laukkujen raahaaminen ruuhkaisessa metrossa ja keskustassa ei olisi naurattanut – varsinkaan, jos lounas olisi jäänyt välistä. Onneksi mukana oli vain käsimatkatavarat, niin hotellille selviydyttiin kolmessa vartissa ja lounastakin saatiin!'
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '6Hewtr5AHSFNzmcba0vOXA',
                type: 'Entry',
                createdAt: '2019-12-30T10:48:30.834Z',
                updatedAt: '2019-12-30T10:48:30.834Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'hotelPhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'Room Mate Mario, Madrid',
                title: 'Viihtyisällä hotellilla on huippusijainti Malasañassa',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '74B2fvjdMLr5WC56hyGxvQ',
                    type: 'Asset',
                    createdAt: '2019-12-30T09:49:24.619Z',
                    updatedAt: '2019-12-30T10:38:46.951Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 2,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Hotellin parvekkeella oli kiva nauttia aamukahvit',
                    description:
                      'Hotellin parvekkeella oli mukava nauttia oman huoneen kahvikoneella keitetyt aamukahvit. Kuva: Tuulia Kolehmainen.',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 11634350,
                        image: {
                          width: 3024,
                          height: 4032
                        }
                      },
                      fileName:
                        '3. Hotellin parvekkeella oli kiva nauttia aamukahvit_MG_6476.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Valitsimme viisaasti hotellin molempien ystävysten lempikaupunginosasta ja parhaiden tapas- ja illanviettobaarien mekasta Malasañasta, joten liikkuminen paikasta toiseen onnistui kävellen. Room Mate Mario -hotelli oli yllättävän rauhallinen keskeiseen sijaintiinsa nähden, ja hyvin varustellun huoneen hintakin oli kohdillaan, kun jätimme aamiaisen varaamatta ja sijoitimme rahat sen sijaan kahviloiden koluamiseen.',
                media: [
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '74B2fvjdMLr5WC56hyGxvQ',
                      type: 'Asset',
                      createdAt: '2019-12-30T09:49:24.619Z',
                      updatedAt: '2019-12-30T10:38:46.951Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 2,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title:
                        'Hotellin parvekkeella oli kiva nauttia aamukahvit',
                      description:
                        'Hotellin parvekkeella oli mukava nauttia oman huoneen kahvikoneella keitetyt aamukahvit. Kuva: Tuulia Kolehmainen.',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 11634350,
                          image: {
                            width: 3024,
                            height: 4032
                          }
                        },
                        fileName:
                          '3. Hotellin parvekkeella oli kiva nauttia aamukahvit_MG_6476.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  }
                ]
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '2Pq9p9dDe8apAvL34dZ56I',
                type: 'Entry',
                createdAt: '2019-12-30T10:49:11.950Z',
                updatedAt: '2019-12-30T10:49:11.950Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'experiencePhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'Tapaksia ja tanssia',
                title:
                  'Madridin yö alkaa tapaksilla ja päättyy tanssilattialle',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '3h7t36Ikg8v1Wcf3PjoZ6Q',
                    type: 'Asset',
                    createdAt: '2019-12-30T10:35:59.521Z',
                    updatedAt: '2019-12-30T10:43:49.540Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 3,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Tapaksia La Mucca del Carmenissa',
                    description:
                      'La Mucca del Carmenin ihanat tapakset kutsuivat luokseen kahtena iltana. Kuva: Tuulia Kolehmainen.',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 9095693,
                        image: {
                          width: 4032,
                          height: 3024
                        }
                      },
                      fileName: '4. La Mucca del Carmen-IMG_1870.JPG',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                content:
                  'Hotellin läheltä löytyi jo ensimmäisenä iltana tapasbaari, joka näytti kalliilta turistipaikalta, mutta olikin edullinen ja paikallisten suosima! La Mucca del Carmenin tapakset olivat niin makoisia – suolassa, rasvassa ja raaka-aineiden tuoreudessa ei ollut säästelty – että päädyimme tänne myös lauantaina patatas bravas -perunoilla, pimenton-paprikoilla, turskalla ja valkosipulikatkaravuilla herkuttelemaan.\n\nIlta jatkui Malasañassa, legendaarisessa vermuttibaari Casa Camachossa. Autenttista elämystä pilasivat vain yli-innokkaiden selfienäpsijöiden salamavalot, joista baarimikkokin hieman suutahti.\n\nVermuttibaarista kävelimme viereiseen Lavapiesin kaupunginosaan, Traveling Bariin, jossa yö huipentui iloisesti tanssien. Madridissa parasta on se, ettei tanssiakseen ole pakko mennä ökyklubikomplekseihin, vaan rokkaavampaakin menoa löytyy pienten baarien uumenista.',
                media: [
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '3h7t36Ikg8v1Wcf3PjoZ6Q',
                      type: 'Asset',
                      createdAt: '2019-12-30T10:35:59.521Z',
                      updatedAt: '2019-12-30T10:43:49.540Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 3,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Tapaksia La Mucca del Carmenissa',
                      description:
                        'La Mucca del Carmenin ihanat tapakset kutsuivat luokseen kahtena iltana. Kuva: Tuulia Kolehmainen.',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 9095693,
                          image: {
                            width: 4032,
                            height: 3024
                          }
                        },
                        fileName: '4. La Mucca del Carmen-IMG_1870.JPG',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: 'deiQ6ZXrPiC1xNQy0wRMo',
                      type: 'Asset',
                      createdAt: '2019-12-30T10:36:57.634Z',
                      updatedAt: '2019-12-30T10:37:23.337Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 2,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title:
                        'La Mucca del Carmen oli ilahduttava tapasbaarilöytö',
                      description:
                        'La Mucca del Carmen oli ilahduttava tapasbaarilöytö. Kuva: Tuulia Kolehmainen',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 822659,
                          image: {
                            width: 768,
                            height: 1024
                          }
                        },
                        fileName:
                          '5. La Mucca del Carmen oli ilahduttava tapasbaarilöytö_323b.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '1Ui0nzwGfJDd4PO4wy2cMH',
                      type: 'Asset',
                      createdAt: '2019-12-30T10:40:01.506Z',
                      updatedAt: '2019-12-30T10:43:32.479Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 2,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Vermuttia Casa Camachossa',
                      description:
                        'Vermutti on Madridin hittijuoma. Kuva: Tuulia Kolehmainen.',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 5531201,
                          image: {
                            width: 2320,
                            height: 3088
                          }
                        },
                        fileName: '6. Vermutti.JPG',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '3WhfpihsgTIzG92jYOYUv7',
                      type: 'Asset',
                      createdAt: '2019-12-30T10:41:47.125Z',
                      updatedAt: '2019-12-30T10:41:47.125Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Vermuttia tarjoiltiin monenlaisista laseista',
                      description:
                        'Vermuttia tarjoiltiin monenlaisista laseista. Kuva: Tuulia Kolehmainen.',
                      file: {
                        url:
                          '//downloads.ctfassets.net/bh7k0sgo84rb/3WhfpihsgTIzG92jYOYUv7/56440634d59b5596a842043e1cbea92d/6._vermuttia_tarjoiltiin_monenlaisista_laseista_MG_9827.jpg',
                        details: {
                          size: 39165218,
                          image: {
                            width: 3648,
                            height: 5472
                          }
                        },
                        fileName:
                          '6. vermuttia tarjoiltiin monenlaisista laseista_MG_9827.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '1SHmivJdIlTxAF8tFcRsjj',
                      type: 'Asset',
                      createdAt: '2019-12-30T10:42:59.578Z',
                      updatedAt: '2020-01-03T13:06:35.419Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 3,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Casa Camacho, Madrid',
                      description:
                        ' Casa Camacho on koko kaupungin tunnetuin vermutería. Kuva: Tuulia Kolehmainen.',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 7349838,
                          image: {
                            width: 4819,
                            height: 2453
                          }
                        },
                        fileName:
                          'Casa Camacho on koko kaupungin tunnetuin vermutería.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  },
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: 'yXpd55dhRCn1NcPVCukaB',
                      type: 'Asset',
                      createdAt: '2019-12-30T10:44:27.061Z',
                      updatedAt: '2019-12-30T10:44:27.061Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Traveling Bar Lavapiésin kaupunginosassa',
                      description:
                        ' Traveling Bar sijaitsee Lavapiésin kaupunginosassa',
                      file: {
                        url: '//localhost:3000/static/test/dummy-image.png',
                        details: {
                          size: 11794472,
                          image: {
                            width: 4032,
                            height: 3024
                          }
                        },
                        fileName:
                          '8. Traveling Bar sijaitsee Lavapiésin kaupunginosassa_IMG_8439.jpg',
                        contentType: 'image/jpeg'
                      }
                    }
                  }
                ]
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '6Wk5uodouwJVznfPpbHCag',
                type: 'Entry',
                createdAt: '2019-12-30T10:49:40.581Z',
                updatedAt: '2019-12-30T10:49:40.581Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'travelPhase'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                label: 'Madrid - Helsinki',
                title: 'Pitkä viikonloppu Madridissa piristi talvea',
                mainMedia: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '7sck8UXLNV3flGPRyo3bNF',
                    type: 'Asset',
                    createdAt: '2019-08-21T13:41:18.562Z',
                    updatedAt: '2019-08-21T13:41:18.562Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Lento Helsinki → Lissabon, TAP Portugal',
                    description: 'Lentokoneen auringonlasku oli upee! 🌇',
                    file: {
                      url:
                        '//images.ctfassets.net/bh7k0sgo84rb/7sck8UXLNV3flGPRyo3bNF/d4d93388943fb5251426ae8920becbb7/Screenshot_2019-08-21_at_16.37.39.png',
                      details: {
                        size: 1578510,
                        image: {
                          width: 2134,
                          height: 1242
                        }
                      },
                      fileName: 'Screenshot 2019-08-21 at 16.37.39.png',
                      contentType: 'image/png'
                    }
                  }
                },
                content:
                  'Madridin pitkä viikonloppu tarjosi kaikkea, mitä olimme toivoneetkin: hyvää seuraa, herkullista ruokaa, eläväistä yöelämää ja irtiottoa normiarjesta. Seuraavaa reissua varten jäi ylös muutama paikka, johon ei tällä kertaa ehditty, ainakin muutama Pez-kadun pikkuputiikki, joissa pitää vielä päästä käymään.'
              }
            }
          ],
          destinations: [
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: 'vRUnHG3QlCmdUF8Nv3GtP',
                type: 'Entry',
                createdAt: '2019-12-30T10:56:15.193Z',
                updatedAt: '2019-12-30T10:56:15.193Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'destination'
                  }
                },
                locale: 'fi-FI'
              },
              fields: {
                title: 'Madrid',
                slug: 'madrid',
                mainImage: {
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'bh7k0sgo84rb'
                      }
                    },
                    id: '6582jfDpWLypnJ8GreSZY8',
                    type: 'Asset',
                    createdAt: '2019-12-30T10:56:09.126Z',
                    updatedAt: '2019-12-30T10:56:09.126Z',
                    environment: {
                      sys: {
                        id: 'sandbox1',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    revision: 1,
                    locale: 'fi-FI'
                  },
                  fields: {
                    title: 'Ilmakuva Madrid, Espanja',
                    description: 'Madrid, Espanja',
                    file: {
                      url: '//localhost:3000/static/test/dummy-image.png',
                      details: {
                        size: 2319862,
                        image: {
                          width: 4780,
                          height: 3187
                        }
                      },
                      fileName: 'florian-wehde-WBGjg0DsO_g-unsplash.jpg',
                      contentType: 'image/jpeg'
                    }
                  }
                },
                country: 'Espanja',
                cityErpId: 1249,
                leadParagraph: 'TBD',
                description: 'TBD',
                trips: [
                  {
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'bh7k0sgo84rb'
                        }
                      },
                      id: '3sJFzGhRJnbsurRvQknnTZ',
                      type: 'Entry',
                      createdAt: '2019-12-30T09:27:23.900Z',
                      updatedAt: '2019-12-30T09:27:23.900Z',
                      environment: {
                        sys: {
                          id: 'sandbox1',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: 'Link',
                          linkType: 'ContentType',
                          id: 'trip'
                        }
                      },
                      locale: 'fi-FI'
                    },
                    fields: {
                      title: 'Madridin kaupunkiloma',
                      erpTripId: 1
                    }
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  },
  memory: {
    sys: {
      space: {
        sys: {
          type: 'Link',
          linkType: 'Space',
          id: 'bh7k0sgo84rb'
        }
      },
      id: '7gM0BY8gAYm62Fu2TwyzoJ',
      type: 'Entry',
      createdAt: '2020-01-09T14:45:44.265Z',
      updatedAt: '2020-01-09T14:45:44.265Z',
      environment: {
        sys: {
          id: 'sandbox1',
          type: 'Link',
          linkType: 'Environment'
        }
      },
      revision: 1,
      contentType: {
        sys: {
          type: 'Link',
          linkType: 'ContentType',
          id: 'memory'
        }
      },
      locale: 'fi-FI'
    },
    fields: {
      title: 'Perheen kaupunkiloma Berliinissä herkutellen',
      slug: 'perheen-kaupunkiloma-berliinissa-herkutellen',
      leadParagraph:
        'Teimme kesällä kolmen päivän kaupunkiloman teinien toivekaupunkikohteeseen Berliiniin. Rosoinen suurkaupunki viehätti koskettavine historioineen, monipuolisine nähtävyyksineen ja maittavine ruokapaikkoineen.',
      trip: {
        sys: {
          space: {
            sys: {
              type: 'Link',
              linkType: 'Space',
              id: 'bh7k0sgo84rb'
            }
          },
          id: '4Y08aRL6TvxQBRRtJQgKot',
          type: 'Entry',
          createdAt: '2020-01-09T14:05:38.989Z',
          updatedAt: '2020-01-09T14:05:38.989Z',
          environment: {
            sys: {
              id: 'sandbox1',
              type: 'Link',
              linkType: 'Environment'
            }
          },
          revision: 1,
          contentType: {
            sys: {
              type: 'Link',
              linkType: 'ContentType',
              id: 'trip'
            }
          },
          locale: 'fi-FI'
        },
        fields: {
          title: 'Berliinin kaupunkiloma',
          erpTripId: 860
        }
      },
      mainImage: {
        sys: {
          space: {
            sys: {
              type: 'Link',
              linkType: 'Space',
              id: 'bh7k0sgo84rb'
            }
          },
          id: '3rMqIbljnAk0Kmn5uxUGAt',
          type: 'Asset',
          createdAt: '2020-01-09T14:41:48.568Z',
          updatedAt: '2020-01-09T14:41:48.568Z',
          environment: {
            sys: {
              id: 'sandbox1',
              type: 'Link',
              linkType: 'Environment'
            }
          },
          revision: 1,
          locale: 'fi-FI'
        },
        fields: {
          title: 'Berliinin Tuomiokirkko',
          description: 'Berliinin Tuomiokirkko komeilee jykevänä taustalla.',
          file: {
            url: '//localhost:3000/static/test/dummy-image.png',
            details: {
              size: 8341330,
              image: {
                width: 3024,
                height: 4032
              }
            },
            fileName: 'Berliner-Dom---Berliinin-Tuomiokirkko.jpg',
            contentType: 'image/jpeg'
          }
        }
      },
      startDate: '2020-01-01',
      endDate: '2020-01-04',
      travellers: [
        {
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'bh7k0sgo84rb'
              }
            },
            id: '3OrIlKoWrLzg2Z0MPziJX7',
            type: 'Entry',
            createdAt: '2020-01-09T13:55:13.620Z',
            updatedAt: '2020-01-10T10:09:20.366Z',
            environment: {
              sys: {
                id: 'sandbox1',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            revision: 2,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'traveller'
              }
            },
            locale: 'fi-FI'
          },
          fields: {
            profilePicture: {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '5ETEflYMgFT0MEiuEBSnyM',
                type: 'Asset',
                createdAt: '2020-01-09T13:55:07.542Z',
                updatedAt: '2020-01-10T10:09:15.701Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 2,
                locale: 'fi-FI'
              },
              fields: {
                title: 'Arja Virta',
                file: {
                  url:
                    '//images.ctfassets.net/bh7k0sgo84rb/5ETEflYMgFT0MEiuEBSnyM/0df24bcc7a3d0964054ee231be08b0d5/Arja_Eze_082018.png',
                  details: {
                    size: 4544625,
                    image: {
                      width: 1936,
                      height: 1452
                    }
                  },
                  fileName: 'Arja Eze 082018.png',
                  contentType: 'image/png'
                }
              }
            },
            title: 'Arja Virta',
            firstName: 'Arja',
            slug: 'arja-virta',
            shortInfo: 'Kauniita maisemia rakastava reissaaja',
            residence: 'Turku',
            instagramHandle: 'instagram.com/elamanmakuisiamatkoja',
            homepage: {
              sys: {
                type: 'Link',
                linkType: 'Entry',
                id: '7FjypyBp04HeYDQdlbda1f'
              }
            },
            leadParagraph:
              'Matkustan usein perheen kanssa. Lapset ovat teini-ikäisiä, yksi jo aikuinenkin. Haluamme\nnähdä maailmaa ja tutustua kohteisiin myös nuorten näkökulmasta, samalla perheen kanssa\naikaa viettäen.'
          }
        }
      ],
      phases: [
        {
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'bh7k0sgo84rb'
              }
            },
            id: '1C3rxDtoWUjDueI63OlYXk',
            type: 'Entry',
            createdAt: '2020-01-09T14:45:16.203Z',
            updatedAt: '2020-01-09T14:45:16.203Z',
            environment: {
              sys: {
                id: 'sandbox1',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            revision: 1,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'travelPhase'
              }
            },
            locale: 'fi-FI'
          },
          fields: {
            label: 'Turku–Berliini',
            title: 'Matka alkoi aamulennolla Turusta Berliiniin',
            mainMedia: {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '3z2Gy1ehP56BC53xR5Zv1k',
                type: 'Asset',
                createdAt: '2020-01-09T14:45:04.554Z',
                updatedAt: '2020-01-09T14:45:04.554Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                locale: 'fi-FI'
              },
              fields: {
                title: 'Tunnelmaa',
                description:
                  'Tällaisiin tunnelmiin perhematka johti entisessä Itä-Berliinissä.',
                file: {
                  url: '//localhost:3000/static/test/dummy-image.png',
                  details: {
                    size: 9872962,
                    image: {
                      width: 2891,
                      height: 3854
                    }
                  },
                  fileName: 'Tunnelmaa-entisen-Ita-Berliinin-alueelta.jpg',
                  contentType: 'image/jpeg'
                }
              }
            },
            content:
              'Matkaan Turusta lähdimme aamuvarhaisella auringon piirtäessä kultaisia ja punertavia sävyjään taivaanrantaan. Jo ensimmäisenä päivänä ehdimme viettää koko päivän perillä ja kesäisen kansainvälinen suurkaupunki tempaisi meidät sykkeeseensä. '
          }
        },
        {
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'bh7k0sgo84rb'
              }
            },
            id: '6JIVu8lbLDujQzeSC6pxhP',
            type: 'Entry',
            createdAt: '2020-01-09T14:22:22.699Z',
            updatedAt: '2020-01-09T14:22:22.699Z',
            environment: {
              sys: {
                id: 'sandbox1',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            revision: 1,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'hotelPhase'
              }
            },
            locale: 'fi-FI'
          },
          fields: {
            label: 'Scandic Potsdamer Platz',
            title: 'Hotellin Scandic Potsdamer Platzin sijainti oli keskeinen',
            mainMedia: {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '65R8UxO3TZ0JVPvUFHchjV',
                type: 'Asset',
                createdAt: '2020-01-09T14:15:49.173Z',
                updatedAt: '2020-01-09T14:15:49.173Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                locale: 'fi-FI'
              },
              fields: {
                title: 'Potsdamer Platzin asemalla',
                description:
                  'Potsdamer Platzin asemaa ympäröivät mielenkiintoisen näköiset rakennukset.',
                file: {
                  url: '//localhost:3000/static/test/dummy-image.png',
                  details: {
                    size: 2211397,
                    image: {
                      width: 2721,
                      height: 3629
                    }
                  },
                  fileName: 'Potsdamer Platzin asemalla.JPG',
                  contentType: 'image/jpeg'
                }
              }
            },
            content:
              'Scandic Potsdamer Platz -hotellin keskeinen sijainti helpotti liikkumista kaupungissa.  U-Bahn asema on vieressä ja junan ikkunasta voi ihailla suurkaupungin siluettia ja ihmisvilinää. Potsdamer Platz -aukion ja ympäristön arkkitehtoniset ratkaisut ja minimalistiset rakennukset miellyttivät silmää.'
          }
        },
        {
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'bh7k0sgo84rb'
              }
            },
            id: '2BbZKfmgfSawtDtO1PpWJ',
            type: 'Entry',
            createdAt: '2020-01-09T14:21:51.354Z',
            updatedAt: '2020-01-09T14:21:51.354Z',
            environment: {
              sys: {
                id: 'sandbox1',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            revision: 1,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'experiencePhase'
              }
            },
            locale: 'fi-FI'
          },
          fields: {
            label: 'Makunautintoja',
            title: 'Makunautintoja Potsdamer Platzilla ',
            mainMedia: {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: 'CVwwRWd55HJiUbEvfMf93',
                type: 'Asset',
                createdAt: '2020-01-09T14:21:05.873Z',
                updatedAt: '2020-01-09T14:21:32.551Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 2,
                locale: 'fi-FI'
              },
              fields: {
                title: 'Que Pasa -ravintolassa',
                description:
                  'Nautimme hyvästä meksikolaisesta ruuasta Que Pasa -ravintolassa.',
                file: {
                  url: '//localhost:3000/static/test/dummy-image.png',
                  details: {
                    size: 1493879,
                    image: {
                      width: 2095,
                      height: 3724
                    }
                  },
                  fileName: 'Que Pasa -ravintolassa.jpg',
                  contentType: 'image/jpeg'
                }
              }
            },
            content:
              'Berliinin ruokatarjonta on todella monipuolista ja herkullista. Jo ensimmäisenä iltana löysimme perheemme suosikkiravintolan Potsdamer Platzilta. Meksikolaisen Que Pasa -ravintolan terassilla oli miellyttävä istua lämpimänä kesäiltana ja ravintolan ruuat hivelivät makuaisteja. Perheen nirsot teinitkin kehuivat annoksiaan ylitsevuotavasti. Hinta-laatusuhde oli erinomainen, paikka viihtyisä ja ruoka erinomaista. Que Pasa sai meidän perheeltämme täydet viisi pistettä kahden illan kokemuksella.'
          }
        },
        {
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'bh7k0sgo84rb'
              }
            },
            id: '2F0ewR2NHYQPIVjIyO0yKl',
            type: 'Entry',
            createdAt: '2020-01-09T14:27:41.219Z',
            updatedAt: '2020-01-09T14:27:41.219Z',
            environment: {
              sys: {
                id: 'sandbox1',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            revision: 1,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'experiencePhase'
              }
            },
            locale: 'fi-FI'
          },
          fields: {
            label: 'Herkkuja ja shoppailua',
            title: 'Herkkuja ja shoppailua KaDeWessa',
            mainMedia: {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: 'GjuuqbslZfJSF2fECMUe2',
                type: 'Asset',
                createdAt: '2020-01-09T14:27:25.787Z',
                updatedAt: '2020-01-09T14:27:25.787Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                locale: 'fi-FI'
              },
              fields: {
                title: 'KaDeWen herkkuosastolla',
                description:
                  'Suklaiset ja marjaiset herkut vievät kielen mennessään.',
                file: {
                  url: '//localhost:3000/static/test/dummy-image.png',
                  details: {
                    size: 2692070,
                    image: {
                      width: 4032,
                      height: 3024
                    }
                  },
                  fileName: 'KaDeWe-tavaratalon herkkuosastolla.jpg',
                  contentType: 'image/jpeg'
                }
              }
            },
            content:
              'Ihania herkkuja ja kauniita esillepanoja ihailimme myös KaDeWessa (Kaufhaus des Westens eli Lännen tavaratalo). Ylellinen ostospaikka on suuri, Lontoon Harrodsin mieleen tuova luksustavaratalo. Yläkerroksen foodmarketissa oli muun muassa ihania, suklaisia ja marjaisia herkkuja, tuoreita ruokatarvikkeita ja herkullisen värisiä juomia houkuttelevasti esillä. Himoitsimme niitä myös kotiin vietäväksi, mutta valitettavasti matkustimme tällä kertaa vain käsimatkatavaroilla, joten ne jäivät hyllyille.'
          }
        },
        {
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'bh7k0sgo84rb'
              }
            },
            id: '5Y56lNXYUfRGmxe4pMHDGy',
            type: 'Entry',
            createdAt: '2020-01-09T14:35:41.051Z',
            updatedAt: '2020-01-09T14:35:41.051Z',
            environment: {
              sys: {
                id: 'sandbox1',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            revision: 1,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'experiencePhase'
              }
            },
            locale: 'fi-FI'
          },
          fields: {
            label: 'Tunnelmaa ja ostoksia',
            title: 'Entisen Itä-Berliinin tunnelmaa ja ostoksia lännessä',
            mainMedia: {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '1Do2c1C8NUx9Jg8vzK6qJR',
                type: 'Asset',
                createdAt: '2020-01-09T14:35:35.893Z',
                updatedAt: '2020-01-09T14:35:35.893Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                locale: 'fi-FI'
              },
              fields: {
                title: 'Alexanderplatz',
                description: 'Berliiniä Alexanderplatzin ympäristössä.',
                file: {
                  url: '//localhost:3000/static/test/dummy-image.png',
                  details: {
                    size: 9198938,
                    image: {
                      width: 3024,
                      height: 4032
                    }
                  },
                  fileName:
                    'Itä-Berliinin-alueella-Alexanderplatzin-ympäristössä.jpg',
                  contentType: 'image/jpeg'
                }
              }
            },
            content:
              'Kauniina kesäiltana monipuolisten nähtävyyksien kiertelyn jälkeen kävimme tyttären kanssa vielä Alexanderplatzin ympäristössä entisen Itä-Berliinin puolella. Alue oli yllättävän rauhallinen elämää kuhisevan miljoonakaupungin mittapuulla.\n\nVaalean pastellin sävyiset vanhat talot olivat kauniita ja liikkeet tyylikkäitä. Pienet, viehättävät kortteliravintolat vetivät ihmisiä nauttimaan herkullisista aterioista, kuplivista juomista ja lempeästä kesäillasta.\n\nMeillä ostoksien aika oli vasta seuraavana päivänä. Nuoret löysivät kaikki suosikkikauppansa Ku’dammin (Kurfürstendamm ympäristöineen) kierroksella ja ostoskassit täyttyivät edullisista löydöistä. Kiitimme onneamme, että osuimme paikalle aleaikaan! '
          }
        },
        {
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'bh7k0sgo84rb'
              }
            },
            id: '4NJ2SS79MDwnRV8OFwsrwK',
            type: 'Entry',
            createdAt: '2020-01-09T14:39:25.995Z',
            updatedAt: '2020-01-09T14:39:25.995Z',
            environment: {
              sys: {
                id: 'sandbox1',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            revision: 1,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'travelPhase'
              }
            },
            locale: 'fi-FI'
          },
          fields: {
            label: 'Positiivinen yllätys',
            title: 'Berliini oli positiivinen yllätys',
            mainMedia: {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '3cysfevnyqlfZc2gVlxWiq',
                type: 'Asset',
                createdAt: '2020-01-09T14:39:20.725Z',
                updatedAt: '2020-01-09T14:39:20.725Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                locale: 'fi-FI'
              },
              fields: {
                title: 'Holocaust Memorial',
                description: 'Lapset tutustumassa Holocaust Memorialiin.',
                file: {
                  url: '//localhost:3000/static/test/dummy-image.png',
                  details: {
                    size: 1725233,
                    image: {
                      width: 3654,
                      height: 2740
                    }
                  },
                  fileName: 'Lapset Holocaust Memorialilla.JPG',
                  contentType: 'image/jpeg'
                }
              }
            },
            content:
              'Ennakko-odotuksiini nähden kokemus Berliinistä oli yllättävän positiivinen. Kaupunki ei niinkään hurmannut kauneudellaan, mutta suurkaupungista löytyi kuitenkin taidokasta arkkitehtuuria ja rosoista vetovoimaa. Rento, kansainvälinen ilmapiiri ja ruuhkattomuus muutamia suosituimpia nähtävyyksiä lukuun ottamatta vetosivat sekä aikuisiin että nuoriin.'
          }
        }
      ],
      destinations: [
        {
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'bh7k0sgo84rb'
              }
            },
            id: '4NGGMKDbUykH0PzSSFDd84',
            type: 'Entry',
            createdAt: '2020-01-09T14:06:06.850Z',
            updatedAt: '2020-01-09T14:06:06.850Z',
            environment: {
              sys: {
                id: 'sandbox1',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            revision: 1,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'destination'
              }
            },
            locale: 'fi-FI'
          },
          fields: {
            title: 'Berliini',
            slug: 'berliini',
            mainImage: {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '6btFJxs7VWn8AeCJncdyR0',
                type: 'Asset',
                createdAt: '2020-01-09T14:04:10.992Z',
                updatedAt: '2020-01-09T14:04:10.992Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                locale: 'fi-FI'
              },
              fields: {
                title: 'Berliini',
                description: 'Berliini, Saksa',
                file: {
                  url: '//localhost:3000/static/test/dummy-image.png',
                  details: {
                    size: 28825,
                    image: {
                      width: 300,
                      height: 200
                    }
                  },
                  fileName: 'berliini-saksa-016-300x200.jpg',
                  contentType: 'image/jpeg'
                }
              }
            },
            country: 'Saksa',
            cityErpId: 856,
            leadParagraph: 'TBD',
            description: 'TBD',
            trips: [
              {
                sys: {
                  space: {
                    sys: {
                      type: 'Link',
                      linkType: 'Space',
                      id: 'bh7k0sgo84rb'
                    }
                  },
                  id: '4Y08aRL6TvxQBRRtJQgKot',
                  type: 'Entry',
                  createdAt: '2020-01-09T14:05:38.989Z',
                  updatedAt: '2020-01-09T14:05:38.989Z',
                  environment: {
                    sys: {
                      id: 'sandbox1',
                      type: 'Link',
                      linkType: 'Environment'
                    }
                  },
                  revision: 1,
                  contentType: {
                    sys: {
                      type: 'Link',
                      linkType: 'ContentType',
                      id: 'trip'
                    }
                  },
                  locale: 'fi-FI'
                },
                fields: {
                  title: 'Berliinin kaupunkiloma',
                  erpTripId: 860
                }
              }
            ]
          }
        }
      ]
    }
  }
};
